import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import moment from 'moment';
import { Highlights } from 'src/app/hire-person-search/Highlights';
import { CompanyHoverModalComponent } from 'src/app/company-hover-modal/company-hover-modal.component';
import { HireCompanyHoverModalComponent } from '../hire-company-hover-modal/hire-company-hover-modal.component';
import { MomentPipe } from 'src/app/hire-person-search/pipes/moment.pipe';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CampaignService } from 'src/app/_services/campaign.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';
import { AddToCampaignComponent } from '../add-to-campaign/add-to-campaign.component';
declare const clevertap;
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { AddToPipelineComponent } from '../add-to-pipeline/add-to-pipeline.component';
import { ActivatedRoute } from '@angular/router';
import { FilterStoreService } from '../store/filter-store.service';
import { IDEAL_CANDIDATE_CHIP_LABELS, RoleFitDataService } from '../services/role-file-data.service';
import { AddToPipelineStageComponent } from '../add-to-pipeline-stage/add-to-pipeline-stage.component';
import { UploadCandidateService } from 'src/app/projects/services/upload-candidate.service';
import { AggregateService } from 'src/app/projects/services/aggregate.service';
import { CandidateSelectionService } from 'src/app/projects/services/candidate-selection.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

type FFHUnicornTierOne = {
  fortune500: string[];
  unicorn: string[];
  tierOneSchools: string[];
};

// IDEAL_CANDIDATE_CHIP_LABELS now lives in role-fit-data.service.ts (imported above)
// so it stays in sync with hire-candidate-list's bulk backfill logic.
@Component({
  selector: 'app-hire-candidate-card',
  imports: [TitleCasePipe, CommonModule, HireCompanyHoverModalComponent, MomentPipe, ReactiveFormsModule, NgbModule, AddToCampaignComponent, AddToPipelineComponent, AddToPipelineStageComponent, MatTooltipModule],
  templateUrl: './hire-candidate-card.component.html',
  styleUrls: ['./hire-candidate-card.component.scss'],
  standalone: true

})
export class HireCandidateCardComponent {
@Input() candidate: any; // Input property to receive candidate data
primaryCompanyInformation:any = {};
currentCompany: string | null = null;
currentJobTitle: string | null = null;
currentTenure: string | null = null;
currentexplocation: string | null = null;
currentStartDate: any = null;
totalTenure: string | null = null;
@Input() index: number | null = null; // Input property to receive index
highlightsList: any[] = []; // Array to hold the highlights data
highlightsPillData = new Highlights();
highlights: MatchHighlights;
hasSomeFilter: boolean = false;
clonedExperience: any[] = [];
currentCompanyInformation:any  = {};
  @Output() childEvents = new EventEmitter<{action : string, data: any, index: number | null}>();
  campaignSearch = new FormControl('');
  @Input() campaignList: any[] = []; // Input property to receive campaign list
  isDropdownOpen = false;
filteredCampaigns: any[] = [...this.campaignList]; // Initialize filtered campaigns with the full campaign list
selectedCampaign: any = null;
isLoadingEmailCampaignApi: boolean = false;
  campaignCandidatesArray: any[] = [];
    emailFoundCount: number;
    successMessage: string = '';
    errorMessage: string = '';
    @ViewChild('addToEmailCampaignWithViewCampaign') addToEmailCampaignWithViewCampaign: TemplateRef<any>;
    campaignName: string = '';
@Input() summarizeScreeningCriteria: any[];
// Keyed (c1, c2, ...) map of the raw criteria text actually sent to the score API,
// used to show the original criteria name on the chip tooltip (see buildCriteriaChips).
@Input() rawScreeningCriteriaText: Record<string, string> = {};
criteriaChips: any[] = [];
showCategoryChip: boolean = true;
@Input() projectList: any[] = []; // Input property to receive project list
searchType: string = 'search'; // Default value for searchType
shortSummary: any = null; // Input property to receive short summary data
@Input() isChecked: boolean = false; // driven by parent (select-all or individually toggled)
@Output() selectionChange = new EventEmitter<{ id: string, checked: boolean }>();
@Output() selectedCandidateDetails = new EventEmitter<any>();
@Input() calledFrom: string | null = null;
@Input() stageList: any;

projectnumber: string = '';
@Input() referenceElasticId: string | null = null;
@Input() referenceCandidateData: any = null;
isReRunAiScreeningLoading: boolean = false;
screeningSuccessMessage: string = '';
subscription: Subscription[] = [];
redirectSource: string | null = null;
sociaProfiles:any
socialPlatforms:any = [
{ name: "facebook", count: 29405441, fillRate: "3.8984%", needed: true, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6324_46)">
<path d="M0 0H0.571337H11.4116H12V12H8.26959H6.39522H0V11.4019V0.573746V0Z" fill="#3B579D"/>
<path d="M6.3991 5.53629C6.40927 4.98388 6.37612 4.40975 6.41742 3.85917C6.46151 3.27142 6.71435 2.68669 7.17839 2.3077C7.75849 1.83392 8.41156 1.80083 9.12855 1.81899C9.46064 1.82676 9.79232 1.8468 10.123 1.87907L10.1231 3.49994C10.0985 3.49916 10.074 3.4986 10.0495 3.49829L9.46777 3.4975C9.23782 3.49749 9.02087 3.48724 8.79461 3.53752C8.20883 3.6677 8.27227 4.25669 8.27258 4.72219L8.27314 5.53725L10.057 5.5359C9.98858 6.13463 9.89531 6.73544 9.82617 7.33439C9.31735 7.32823 8.78154 7.33055 8.27223 7.33539L8.27302 10.2578C8.27312 10.7956 8.2841 11.379 8.27175 11.9128C8.27033 11.9407 8.26765 11.9725 8.26959 12H6.39522L6.39975 11.9858C6.3916 11.8944 6.39928 11.6113 6.39937 11.5101L6.39966 10.5047L6.40108 7.33306C5.8841 7.33997 5.3525 7.33418 4.83444 7.33425L4.83406 5.53834C5.34898 5.52931 5.88249 5.53677 6.3991 5.53629Z" fill="#FDFDFD"/>
<path d="M11.4116 0H12V12H8.26959C8.26765 11.9724 8.27033 11.9407 8.27174 11.9128C8.2739 11.9445 8.27266 11.9514 8.28546 11.9796C8.3337 11.9869 8.53248 11.9807 8.59215 11.9806L9.25039 11.9808L10.6026 11.9806C10.8101 11.9808 11.3262 12.0053 11.5065 11.9526C11.6753 11.9029 11.8171 11.7877 11.9004 11.6328C11.9511 11.5399 11.979 11.4364 11.9818 11.3306C11.9908 11.0772 11.9822 10.7651 11.982 10.5079L11.9819 8.94511L11.982 4.10154V1.67904L11.9825 1.06092C11.9828 0.911036 11.9869 0.754121 11.9789 0.605488C11.9663 0.372851 11.7939 0.146921 11.5816 0.0575925C11.5301 0.0359718 11.4553 0.0248577 11.4116 0Z" fill="#FDFDFD"/>
<path d="M0 11.4019C0.190987 12.0665 0.597751 11.9833 1.15754 11.9813L2.13045 11.981H5.34303L6.06683 11.9803C6.13166 11.9802 6.34872 11.9756 6.39975 11.9858L6.39522 12H0V11.4019Z" fill="#FDFDFD"/>
<path d="M0 0H0.571021C0.521231 0.0211577 0.466236 0.0291481 0.416928 0.0490161C0.257001 0.113457 0.126002 0.243447 0.0584511 0.401753C0.0296403 0.466019 0.021043 0.522654 0 0.573429V0Z" fill="#FDFDFD"/>
</g>
<defs>
<clipPath id="clip0_6324_46">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: 2, color: "#484B59" },
{ name: "twitter", count: 11832556, fillRate: "1.5587%", needed: false, icon:`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6324_282)">
<path d="M0 0H12V12H0V0Z" fill="black"/>
<path d="M8.53623 2.55349L9.12178 2.5548C8.91393 2.75616 8.63869 3.11102 8.43811 3.34039L6.61142 5.45912C6.67694 5.53467 6.80545 5.726 6.86469 5.81099L7.39098 6.57924L8.56363 8.27855C8.81944 8.65233 9.08559 9.05743 9.35076 9.42218L9.08124 9.42193L7.35948 9.42174C7.11758 9.04282 6.85048 8.68299 6.6007 8.31025C6.2458 7.78063 5.86683 7.26362 5.51916 6.72975C4.81018 7.58911 4.05266 8.41712 3.3396 9.27385C3.29853 9.3232 3.25766 9.37267 3.2173 9.42262C3.0223 9.42072 2.82728 9.42105 2.63228 9.4236L4.62423 7.10444C4.8409 6.85434 5.04167 6.60826 5.26454 6.36268C5.21456 6.30931 5.05518 6.06621 5.00984 5.99922C4.86157 5.78096 4.71212 5.56352 4.56147 5.3469L3.54966 3.88025C3.25345 3.44573 2.94428 2.9811 2.63607 2.55566C3.29101 2.54596 3.96585 2.55488 4.62314 2.55374C4.65597 2.61255 4.75285 2.74046 4.79459 2.80198C4.92166 2.99325 5.05095 3.18302 5.18246 3.37127L5.97112 4.51627C6.09896 4.702 6.24288 4.8979 6.36533 5.08357C6.41485 5.01056 6.53752 4.87371 6.59808 4.8032L7.01609 4.31832L8.06551 3.09611C8.21777 2.91881 8.38997 2.73099 8.53623 2.55349Z" fill="#FEFEFE"/>
<path d="M3.50067 3.00656C3.72281 3.02313 4.14973 3.01058 4.38585 3.0083C4.71526 3.50717 5.0897 4.03066 5.43016 4.52542L7.44076 7.4486C7.79463 7.95263 8.14397 8.4598 8.48874 8.97008C8.22606 8.96005 7.86904 8.96537 7.60317 8.97064C7.54913 8.87331 7.39107 8.66486 7.31833 8.55759L6.52981 7.40964L4.68707 4.73002C4.29761 4.16777 3.87713 3.5746 3.50067 3.00656Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_6324_282">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: 3, color: "#484B59" },
{ name: "github", count: 1985858, fillRate: "0.2633%", needed: true, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6324_41)">
<path d="M0 0H5.49943H6.47739H12V5.4429V6.33492V12H0V6.27882V5.4679V0Z" fill="black"/>
<path d="M7.51359 3.04132C8.00825 2.75515 8.5496 2.38056 9.16075 2.43157C9.34008 2.90068 9.43912 3.52696 9.22373 4.0024C9.74091 4.57533 9.87423 5.14255 9.82839 5.89544C9.78538 6.60169 9.58642 7.2723 9.04928 7.76543C8.54597 8.22751 7.77275 8.4358 7.10024 8.49267C7.38647 8.75535 7.49249 9.12978 7.50401 9.50846C7.52157 10.0853 7.48198 10.668 7.50814 11.2435C7.51548 11.4049 7.65636 11.515 7.81281 11.4979C7.99669 11.4779 8.18537 11.395 8.3545 11.3224C9.18124 10.9761 9.91977 10.4486 10.5157 9.77904C11.1719 9.04233 11.6321 8.15226 11.8539 7.1909C11.9099 6.94397 11.9455 6.69282 11.9786 6.44191C11.9832 6.40549 11.9865 6.36937 12 6.3349V12H0V6.2788C0.0275598 6.4216 0.0385423 6.56952 0.0588558 6.71414C0.0893558 6.93732 0.133243 7.15845 0.19028 7.37635C0.558101 8.75428 1.41202 9.95262 2.59438 10.7501C2.90742 10.9621 3.947 11.5574 4.28578 11.4907C4.35546 11.477 4.42488 11.4364 4.46534 11.377C4.55234 11.2493 4.51131 10.3219 4.5099 10.1084C4.02848 10.2134 3.34661 10.2234 2.91197 9.95018C2.46585 9.6697 2.42493 9.05537 2.02624 8.70551C1.88023 8.57737 1.67309 8.49156 1.59552 8.32054C1.55927 8.22564 1.77238 8.19831 1.82749 8.19549C2.35182 8.1687 2.65504 8.60684 2.9199 8.98203C3.13263 9.28337 3.55586 9.47107 3.91748 9.44072C4.11342 9.42679 4.36334 9.36742 4.54219 9.28174C4.57785 8.98203 4.70052 8.69969 4.9211 8.49007C3.06581 8.36602 2.095 7.25776 2.19771 5.41623C2.22415 4.94225 2.45438 4.32515 2.80976 4.00334C2.6553 3.61657 2.65689 3.16614 2.7604 2.76641C2.77879 2.6954 2.82333 2.47921 2.88298 2.43904C2.99557 2.40433 3.23913 2.45005 3.35251 2.47963C3.77095 2.58879 4.15148 2.81349 4.51369 3.04239C5.61797 2.77436 6.41311 2.77974 7.51359 3.04132Z" fill="white"/>
<path d="M0 0H5.49943C5.45213 0.0280794 5.10361 0.0657949 5.02336 0.0782763C4.73037 0.123843 4.45741 0.188975 4.17442 0.277798C2.33467 0.848292 0.88446 2.2734 0.28195 4.10293C0.194651 4.37299 0.126946 4.64899 0.0793589 4.9288C0.0619116 5.03328 0.0239767 5.40503 0 5.4679V0Z" fill="white"/>
<path d="M6.47739 0H12V5.4429C11.9754 5.37698 11.9343 5.01172 11.9175 4.91025C11.874 4.6596 11.8143 4.41205 11.7386 4.16918C11.1471 2.29552 9.66884 0.834627 7.7883 0.265471C7.50591 0.178257 7.21729 0.112674 6.92493 0.0692891C6.84875 0.0585785 6.52189 0.0273532 6.47739 0Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_6324_41">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: 4, color: "#484B59" },
{ name: "gravatar", count: 404597, fillRate: "0.0536%", needed: false, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6335_2913)">
<path d="M0 0H12V12H0V0Z" fill="#1D4FC4"/>
<path d="M5.9605 3.00414C6.05096 2.99508 6.21176 3.00617 6.30269 3.01495C7.09305 3.09506 7.81942 3.48526 8.32257 4.10002C8.83174 4.72317 9.06924 5.52475 8.98167 6.32469C8.89841 7.10711 8.50954 7.82499 7.89967 8.32215C7.27544 8.83173 6.4727 9.06924 5.6717 8.98135C4.88744 8.89599 4.16855 8.50458 3.67124 7.89218C2.92614 6.97483 2.7895 5.68933 3.32723 4.63456C3.46483 4.36466 3.7024 4.02052 3.93872 3.82879C3.97876 3.79896 4.02216 3.77394 4.06804 3.75423C4.49032 3.57408 4.95542 3.92938 4.8966 4.38463C4.86572 4.62375 4.67416 4.77216 4.53749 4.95336C4.44837 5.07155 4.39339 5.18077 4.3386 5.31692C4.1534 5.7656 4.1576 6.27014 4.35028 6.71568C4.74678 7.63975 5.81959 8.04481 6.73571 7.64338C7.17044 7.44933 7.50998 7.0901 7.67927 6.64514C7.85138 6.19667 7.83776 5.6981 7.64143 5.25968C7.43469 4.79284 7.06746 4.48447 6.59834 4.3027C6.59364 4.78322 6.6191 5.33168 6.58651 5.80754C6.55856 6.21563 5.96716 6.46186 5.63341 6.17333C5.35387 5.93166 5.40202 5.70779 5.40212 5.36527L5.40252 4.70419L5.4023 3.95509C5.40237 3.83858 5.40321 3.72151 5.40441 3.60503C5.4079 3.26251 5.62097 3.04514 5.9605 3.00414Z" fill="#FEFEFE"/>
</g>
<defs>
<clipPath id="clip0_6335_2913">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: null, color: "#484B59" },
{ name: "youtube", count: 316327, fillRate: "0.0419%", needed: false, icon:`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="12" height="12" rx="1.2" fill="#FE0000"/>
<path d="M5.40189 2.80737C6.34998 2.79333 7.29881 2.81096 8.24564 2.86108C8.79672 2.89029 9.58424 2.8594 10.0191 3.2644C10.4432 3.6596 10.449 4.33881 10.4781 4.87769C10.4975 5.2095 10.5112 5.54247 10.5191 5.87476C10.5343 6.495 10.5153 7.08296 10.4351 7.69702C10.3513 8.33804 10.1993 8.80548 9.50638 8.99292C9.05441 9.11514 8.62855 9.11152 8.16653 9.13354C7.63996 9.16231 7.11277 9.18042 6.58548 9.18823C5.68649 9.2022 4.78696 9.18538 3.88919 9.13647C3.27529 9.10642 2.41989 9.14161 1.94095 8.69507C1.64699 8.42088 1.58799 7.93759 1.54251 7.5564C1.44342 6.7253 1.46546 5.87539 1.50833 5.04077C1.52901 4.64479 1.52958 4.24436 1.63724 3.86108C1.90386 2.87357 2.83633 2.90727 3.66556 2.86499C4.24384 2.83405 4.82282 2.81514 5.40189 2.80737ZM5.08255 4.64624C5.06669 5.54035 5.09039 6.44977 5.07962 7.34546C5.44337 7.13775 5.80537 6.92647 6.16556 6.71265C6.28353 6.64332 6.41979 6.57271 6.53372 6.50269C6.79264 6.34942 7.14073 6.12997 7.39993 5.9978L6.06107 5.21655C5.74452 5.02982 5.40312 4.8239 5.08255 4.64624Z" fill="white"/>
</svg>`, priority: null, color: "#484B59" },
{ name: "klout", count: 301633, fillRate: "0.0400%", needed: true, icon:`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6324_69)">
<rect width="12" height="12" rx="1.2" fill="white"/>
<path d="M11.1191 1.20425C11.626 1.19319 11.9074 1.4596 11.9079 1.97012C11.9085 2.65592 11.9077 3.342 11.9077 4.02781V8.17735L11.9078 9.85983C11.9078 10.0683 11.9223 10.6202 11.8795 10.792C11.8607 10.8069 11.8466 10.8129 11.8221 10.8102C11.7416 10.8016 10.3085 9.97534 10.1147 9.86347C10.0217 9.80979 9.72646 9.622 9.63788 9.60522C9.47358 9.57416 9.16721 9.5942 8.98996 9.59429L7.62614 9.59506L2.31574 9.59516H1.38817C1.19025 9.59516 0.994264 9.59314 0.796387 9.59055C0.434569 9.58567 0.133364 9.33106 0.108872 8.95736C0.0914923 8.64429 0.105008 8.20949 0.104999 7.8872L0.10497 5.84234L0.105344 3.16011L0.104376 2.43091C0.104069 2.25341 0.0888464 1.8852 0.134304 1.73511C0.172639 1.51667 0.316104 1.35551 0.515505 1.26811C0.726639 1.17848 1.03213 1.20313 1.26432 1.20308L2.08559 1.20321L4.59663 1.20325L8.87646 1.2033C9.62044 1.20328 10.376 1.19642 11.1191 1.20425Z" fill="#E44801"/>
<path d="M6.73778 2.4249C6.72685 3.10449 6.72557 3.89134 6.74071 4.56943C7.1155 4.57092 7.53384 4.58093 7.90477 4.5704C8.02956 4.40122 8.14905 4.21979 8.27 4.04697L9.40086 2.42001H11.1245L10.0171 4.03036C9.73064 4.44588 9.44318 4.8716 9.15282 5.28329C9.65692 5.94004 10.1567 6.61895 10.6538 7.28232L11.0727 7.84286C11.1441 7.93827 11.2552 8.09443 11.3354 8.17783C10.7636 8.17051 10.1437 8.1679 9.57274 8.1788C9.4771 8.07727 9.22182 7.70649 9.1245 7.57333L8.17235 6.27451H8.1743L8.08055 6.1456L8.00633 6.20517C8.03066 6.18763 8.0582 6.17076 8.07957 6.1456C8.0286 6.07574 7.95702 5.97311 7.89207 5.91806C7.76569 5.90849 7.61261 5.91129 7.48289 5.91122C7.2418 5.91128 7.00036 5.91342 6.75926 5.91708C6.73309 6.66619 6.76927 7.43093 6.74559 8.17685C6.22804 8.17524 5.68434 8.16816 5.16844 8.1788L5.16747 2.43173C5.69069 2.41601 6.21447 2.41328 6.73778 2.4249Z" fill="white"/>
<path d="M2.62866 2.42062C2.98983 2.91717 3.32273 3.44285 3.68433 3.94016C3.82773 4.13737 3.98866 4.36247 4.11694 4.56906H4.81519V5.91965H4.13745C4.06507 5.98483 3.98392 6.10079 3.92651 6.18039L3.85523 6.28195C3.38949 6.91016 2.93426 7.55098 2.46558 8.17648H0.690187C1.21602 7.45375 1.7691 6.74583 2.29956 6.02609C2.48145 5.77932 2.66739 5.53167 2.85425 5.28879C2.77078 5.17338 2.68674 5.04783 2.60718 4.92941C2.0423 4.08865 1.44538 3.26383 0.886476 2.41965C1.45841 2.42867 2.05477 2.42054 2.62866 2.42062Z" fill="#ED967A"/>
</g>
<defs>
<clipPath id="clip0_6324_69">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: null, color: "#484B59" },
{ name: "angellist", count: 285608, fillRate: "0.0379%", needed: true, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="12" height="12" rx="1.2" fill="white"/>
<path d="M1.8 0.900024H4.26307H4.4094H9.9V6.83104V7.29298V11.1H1.8V8.2707V8.03313V0.900024Z" fill="black"/>
<path d="M1.8 0.900024H4.24921C4.19205 0.922357 4.09445 0.928703 4.02927 0.94628C3.77934 1.01578 3.57741 1.18014 3.47838 1.39465C3.20187 1.97767 3.69479 3.11584 3.90584 3.70514C4.10156 4.25161 4.31901 4.7987 4.5 5.35237C3.87369 4.97454 3.36011 5.17198 2.93903 5.6874C2.82134 5.83145 2.73596 6.03543 2.77735 6.21576C2.82619 6.40117 2.93053 6.65353 3.02541 6.82674C2.75752 6.87622 2.40267 7.00743 2.20547 7.17412C2.00106 7.3469 1.88222 7.62831 1.83942 7.87157C1.82782 7.93745 1.82114 8.03908 1.8 8.10002V0.900024Z" fill="#FEFEFE"/>
<path d="M4.49999 0.900024H9.89999V6.90002C9.88264 6.84467 9.8688 6.66781 9.86032 6.59995C9.8264 6.32625 9.74985 6.00377 9.57159 5.77634C9.34249 5.48404 8.99581 5.35551 8.61655 5.29613C8.62047 5.28788 8.62428 5.27959 8.62797 5.27126C8.79833 4.88599 8.97299 4.40507 9.12434 4.00806C9.34114 3.43938 9.67515 2.64358 9.71024 2.04654C9.72168 1.88098 9.68926 1.71535 9.61569 1.56314C9.52045 1.36723 9.39562 1.23724 9.17074 1.15907C9.01188 1.10384 8.78288 1.07504 8.62403 1.13971C8.43211 1.21784 8.25601 1.40651 8.13558 1.55824C7.93659 1.80893 7.76805 2.09031 7.62073 2.3674C7.36364 2.85097 7.1504 3.35171 6.94663 3.85477C6.83538 4.12941 6.73241 4.41354 6.61415 4.68413C6.55221 4.51726 6.4999 4.34763 6.43746 4.18092C6.38206 4.03299 6.31854 3.88726 6.26056 3.74008C5.97799 3.02277 5.39517 1.55572 4.80176 1.05591C4.73816 1.00235 4.6627 0.960787 4.58288 0.929534C4.55667 0.919275 4.52863 0.914561 4.50357 0.901913C4.50237 0.901304 4.50118 0.900654 4.49999 0.900024Z" fill="#FEFEFE"/>
<path d="M1.8 8.2016C1.8226 8.27432 1.83079 8.41912 1.84879 8.50455C1.90351 8.76408 2.00408 9.10318 2.14873 9.32904C2.64005 10.0963 3.49001 10.7144 4.44906 10.945C5.52463 11.2002 6.75907 11.0822 7.72432 10.5842C8.97341 9.93974 9.74694 8.77707 9.86496 7.50395C9.87239 7.42391 9.8773 7.27348 9.89905 7.20292L9.9 7.20001V11.1H1.8V8.2016Z" fill="#FEFEFE"/>
<path d="M5.72392 5.10429C5.80413 5.09404 6.01064 5.10513 6.09877 5.10722C6.48837 5.11647 6.95036 5.15524 7.33363 5.22196C7.79151 5.30167 8.84075 5.49228 9.11632 5.85766C9.32274 6.13136 9.31431 6.95962 9.28352 7.29719C9.26904 7.45587 9.23947 7.63855 9.20618 7.79608C9.02009 8.69144 8.44833 9.48422 7.61557 10.0017C6.85223 10.4686 5.90269 10.5876 5.00653 10.4409C4.33303 10.3307 3.70121 10.0218 3.23129 9.5787C3.08935 9.45206 2.97186 9.33318 2.85716 9.18311C2.43446 8.63019 2.1008 7.67287 2.82235 7.19918C2.89773 7.14969 3.07218 7.08563 3.16431 7.11168C3.40836 7.18072 3.58038 7.38547 3.74134 7.55269C3.95621 7.76909 4.14058 7.97985 4.31625 8.21985C4.46038 8.42495 4.69653 8.71494 4.43105 8.90018C4.34358 8.96123 4.27451 8.98948 4.16168 8.98144C3.78803 8.95465 3.50828 8.65019 3.29719 8.39865C3.1639 8.2302 3.10626 8.12439 2.94381 7.9595C2.86057 8.0881 2.82379 8.34551 2.86535 8.50005C3.05323 9.19878 4.41439 10.0988 5.0292 9.28108C5.16484 9.10067 5.15185 8.85696 5.09812 8.64767C5.25714 8.6883 5.51343 8.71634 5.63786 8.59522L5.64071 8.59243C5.6506 8.60054 5.65411 8.61592 5.65353 8.62795C5.63181 9.08053 5.73231 9.88107 6.3782 9.93659C6.37642 9.77897 6.35448 9.66702 6.30104 9.51604C6.12103 9.00773 6.09481 8.66956 6.36337 8.1802C6.62862 7.69678 6.9958 7.34564 7.53215 7.09473C7.82326 6.95855 8.12242 6.90497 8.3865 6.71483L8.38562 6.70825C8.37379 6.62065 8.35678 6.49894 8.2625 6.45155C8.16639 6.40324 7.79729 6.42104 7.66701 6.41851C7.11431 6.40776 6.00674 6.35812 5.56518 6.04445C5.40837 5.93307 5.31353 5.78429 5.291 5.60539C5.27544 5.48195 5.27739 5.32424 5.36877 5.22342C5.4577 5.12528 5.59434 5.11632 5.72392 5.10429Z" fill="#FEFEFE"/>
<path d="M4.23365 1.20185C4.3046 1.19765 4.35659 1.19842 4.42173 1.23041C4.55149 1.29413 4.70093 1.5153 4.76173 1.63182C4.8632 1.82627 4.95174 2.05685 5.03076 2.26122L5.32344 3.01435L5.75254 4.10696C5.83148 4.30713 5.93278 4.54466 6 4.74511C5.86473 4.73386 5.72993 4.71832 5.59585 4.69853C5.43998 4.67461 5.25598 4.67654 5.10437 4.72256C5.07816 4.73051 5.02194 4.78099 5.00016 4.80004C4.98016 4.77742 4.85154 4.45498 4.83011 4.40245C4.51675 3.63417 4.19317 2.85215 3.97046 2.05743C3.91785 1.86972 3.8445 1.54481 3.96631 1.38284C4.03847 1.28689 4.1068 1.22952 4.23365 1.20185Z" fill="#FEFEFE"/>
<path d="M8.92849 1.50026C8.95406 1.49853 9.01386 1.50576 9.03788 1.51341C9.49393 1.67963 9.23766 2.26848 9.13574 2.58514C8.93935 3.19525 8.69575 3.82085 8.46144 4.42121C8.4073 4.56038 8.35191 4.69914 8.2953 4.83748C8.26087 4.9209 8.21616 5.01659 8.1893 5.1C8.01389 5.07926 7.85058 5.049 7.67715 5.01656C7.55845 4.99859 7.2997 4.94682 7.19999 4.93906C7.28235 4.76383 7.38988 4.45754 7.46273 4.26957L7.96484 2.97658C8.13118 2.54923 8.30966 2.09962 8.58818 1.71722C8.66927 1.60589 8.77994 1.52237 8.92849 1.50026Z" fill="#FEFEFE"/>
<path d="M3.84428 5.70158C3.90757 5.69895 3.94274 5.69924 4.00544 5.70547C4.28331 5.73813 4.56196 5.97439 4.71366 6.14359C5.07258 6.54388 5.36734 6.98573 5.57749 7.44467C5.62865 7.55639 5.72048 7.72565 5.69589 7.83971C5.67817 7.92099 5.61907 7.99344 5.53174 8.04093C5.42287 8.10002 5.32099 8.10912 5.19501 8.09286C5.08107 8.07363 4.88651 8.02164 4.78061 7.9846C4.70765 7.95906 4.57957 7.85771 4.52064 7.80951C4.1274 7.48807 3.7909 7.11654 3.51514 6.72976C3.44871 6.63107 3.39876 6.5262 3.35433 6.42075C3.29774 6.28639 3.266 6.15177 3.35821 6.02148C3.41261 5.94463 3.48388 5.88642 3.5676 5.8277C3.65506 5.76636 3.73172 5.72821 3.84428 5.70158Z" fill="#FEFEFE"/>
<path d="M5.69999 6.90002C6.03916 7.00373 6.5404 7.08606 6.89933 7.08979C6.79877 7.14923 6.54371 7.33292 6.44854 7.40589C6.34064 7.48937 6.13118 7.69442 6.0549 7.79953C6.00247 7.62668 5.97145 7.47888 5.89252 7.30814C5.83165 7.17646 5.74826 7.0327 5.69999 6.90002Z" fill="#FEFEFE"/>
</svg>`, priority: null, color: "#484B59" },
{ name: "quora", count: 227092, fillRate: "0.0301%", needed: false, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6324_75)">
<path d="M0 0H5.59165H6.39654H12V5.62093V6.3713V12H6.374H5.58139H0V6.36225V5.61668V0Z" fill="#A9201B"/>
<path d="M5.61243 2.56265C7.33648 2.60591 8.55514 3.97079 8.51027 5.67163C8.48928 6.45707 8.16 7.20273 7.59363 7.74733C7.55993 7.77904 7.5259 7.81039 7.49154 7.84138C7.67086 8.0962 7.86166 8.37889 8.19044 8.43487C8.55453 8.49686 8.70447 8.25016 8.77882 7.94916C8.94325 7.94418 9.13075 7.94762 9.29607 7.95313C9.22575 8.43584 9.10659 8.87581 8.698 9.18609C8.41728 9.39928 8.0437 9.46194 7.69997 9.42213C7.17452 9.36129 6.69498 8.87702 6.45134 8.42768C6.21237 8.49366 5.73939 8.59136 5.50504 8.54455C4.84135 8.52781 4.19955 8.24721 3.70595 7.80855C3.11514 7.27648 2.76057 6.53101 2.72062 5.73692C2.66917 4.9301 2.94262 4.13621 3.48 3.53219C4.06813 2.87278 4.7536 2.61143 5.61243 2.56265Z" fill="#A9201B"/>
<path d="M5.61241 2.56265C7.33646 2.60591 8.55512 3.97079 8.51025 5.67163C8.48926 6.45707 8.15998 7.20273 7.59361 7.74733C7.55991 7.77904 7.52588 7.81039 7.49152 7.84138C7.67084 8.0962 7.86164 8.37889 8.19042 8.43487C8.55451 8.49686 8.70445 8.25016 8.77881 7.94916C8.94323 7.94418 9.13073 7.94762 9.29605 7.95313C9.22573 8.43584 9.10657 8.87581 8.69798 9.18609C8.41726 9.39928 8.04368 9.46194 7.69995 9.42213C7.1745 9.36129 6.69497 8.87702 6.45132 8.42768C6.21235 8.49366 5.73937 8.59136 5.50502 8.54455C5.54599 8.5441 5.5591 8.54506 5.59902 8.53384C5.62382 8.47585 5.61009 8.13596 5.60849 8.04873C5.86088 8.01952 5.91318 8.02646 6.15723 7.91912C5.93911 7.61372 5.91007 7.41672 5.58924 7.10959C5.62807 7.04418 5.60936 6.414 5.61143 6.2892C6.2342 6.25706 6.63993 6.51129 6.97967 7.0229C7.20661 6.4781 7.29331 6.10488 7.29242 5.51641C7.29083 4.46732 6.76419 3.05784 5.52451 3.06727C5.558 3.06119 5.57621 3.05989 5.60695 3.04425C5.6215 2.91039 5.60763 2.70818 5.61241 2.56265Z" fill="#D1D1D1"/>
<path d="M5.50504 8.54455C4.84135 8.52781 4.19955 8.24721 3.70595 7.80855C3.11514 7.27648 2.76057 6.53101 2.72062 5.73692C2.66917 4.9301 2.94262 4.13621 3.48 3.53219C4.06813 2.87278 4.7536 2.61143 5.61243 2.56265C5.60765 2.70818 5.62152 2.91039 5.60697 3.04425C5.57623 3.05989 5.55802 3.06119 5.52453 3.06727C5.13377 3.09949 4.81142 3.30567 4.55964 3.60566C4.03751 4.22773 3.89264 5.05684 3.93663 5.84319C3.98668 6.73821 4.55061 8.05549 5.6085 8.04873C5.61011 8.13596 5.62384 8.47585 5.59904 8.53383C5.55912 8.54506 5.54601 8.5441 5.50504 8.54455Z" fill="#FEFEFE"/>
<path d="M4.59369 6.6415C4.93042 6.40257 5.21313 6.33319 5.61088 6.28918C5.60881 6.41391 5.62751 7.04375 5.5887 7.10911C5.38236 6.96009 5.00857 6.93118 4.77128 7.01431L4.59369 6.6415Z" fill="#FEFEFE"/>
</g>
<defs>
<clipPath id="clip0_6324_75">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: null, color: "#484B59" },
{ name: "instagram", count: 219705, fillRate: "0.0291%", needed: false, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6323_873)">
<path d="M0 0H12V12H0V0Z" fill="#F8265E"/>
<path d="M1.50008 4.23702C1.51268 4.05785 1.52114 3.85064 1.55441 3.67579C1.74717 2.66258 2.58208 1.8052 3.58596 1.57551C3.98521 1.48415 4.43297 1.50209 4.84347 1.50232L6.08076 1.50315C6.70332 1.50363 7.37252 1.49004 7.99129 1.51586C8.70014 1.54545 9.37319 1.91371 9.83856 2.45026C10.1318 2.78726 10.3361 3.19224 10.433 3.62836C10.5176 4.00628 10.499 4.42935 10.4988 4.81843L10.498 6.01311L10.4991 7.23033C10.4998 8.27043 10.5098 8.52462 9.95301 9.42154C9.91287 9.47087 9.87166 9.5193 9.8294 9.56682C9.33496 10.1166 8.64232 10.4785 7.90323 10.4934C7.24856 10.5066 6.56755 10.4963 5.91084 10.4967L4.78625 10.4976C4.40553 10.4978 3.95965 10.5146 3.59403 10.4276C3.14313 10.321 2.72752 10.0995 2.38765 9.78462C2.00342 9.43768 1.72795 8.98682 1.59459 8.4866C1.47656 8.04047 1.50519 7.35708 1.50601 6.88219L1.50528 5.05122C1.5039 4.79446 1.51202 4.48784 1.50008 4.23702Z" fill="white"/>
<path d="M4.06666 2.36988C4.25029 2.3463 4.5484 2.36219 4.7397 2.3623L6.00027 2.36339L7.25282 2.3626C7.51733 2.36214 7.89577 2.34868 8.14543 2.39406C8.43901 2.44901 8.71457 2.57526 8.94789 2.76172C9.33199 3.0661 9.57809 3.5117 9.63115 3.9989C9.65565 4.23279 9.64802 4.53257 9.6477 4.77341L9.64734 5.89311L9.64885 7.17021C9.64904 7.47667 9.6639 7.86927 9.60777 8.16393C9.55138 8.45532 9.42328 8.72808 9.23506 8.95757C8.92622 9.3436 8.47491 9.58899 7.98302 9.63837C7.96202 9.64139 7.94091 9.64371 7.91975 9.64533C7.70608 9.66096 7.41266 9.65212 7.19144 9.65207L5.9046 9.65132L4.78993 9.65247C4.49658 9.65354 4.13059 9.67025 3.84812 9.61373C3.53021 9.54946 3.23419 9.40445 2.98856 9.19263C2.29817 8.59568 2.35881 7.93045 2.35863 7.11032L2.35736 5.67378L2.35877 4.69952C2.35814 4.43525 2.34431 4.09745 2.39506 3.84489C2.45728 3.52939 2.60061 3.23553 2.81094 2.99228C3.13027 2.62632 3.58204 2.40239 4.06666 2.36988Z" fill="#F8265E"/>
<path d="M5.89551 3.79041C7.11826 3.71204 8.17219 4.64163 8.24713 5.86459C8.32207 7.08756 7.38953 8.13887 6.16635 8.21037C4.94802 8.2816 3.90179 7.35356 3.82715 6.13543C3.75251 4.91731 4.67761 3.86848 5.89551 3.79041Z" fill="white"/>
<path d="M5.91624 4.59167C6.69444 4.52538 7.37915 5.1022 7.44597 5.88036C7.5128 6.65849 6.93645 7.34361 6.15835 7.41097C5.37948 7.47841 4.69356 6.90137 4.62667 6.12245C4.55978 5.34354 5.13729 4.65801 5.91624 4.59167Z" fill="#FE0D5C"/>
<path d="M8.30032 3.11685C8.59118 3.07443 8.86085 3.27725 8.90079 3.56847C8.94074 3.85967 8.73564 4.12761 8.4441 4.16508C8.15604 4.20212 7.89198 3.99999 7.85252 3.71225C7.81305 3.42451 8.01291 3.15875 8.30032 3.11685Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_6323_873">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: null, color: "#484B59" },
{ name: "stackoverflow", count: 210879, fillRate: "0.0280%", needed: false, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6324_259)">
<path d="M0 0H12V12H0V0Z" fill="white"/>
<path d="M9.1101 7.44791C9.4101 7.46143 9.75596 7.45366 10.0593 7.45384L10.0591 8.34901L10.0586 11.253L1.50354 11.2536L1.50367 8.70801L1.50162 7.9129C1.50126 7.78045 1.4954 7.57795 1.50847 7.45033C1.79156 7.46252 2.16249 7.45362 2.45149 7.4541C2.4439 8.40683 2.44451 9.3596 2.45327 10.3123L9.10922 10.3116C9.13085 9.38172 9.11416 8.38337 9.1101 7.44791Z" fill="#BCBBBB"/>
<path d="M3.68729 6.24448L6.23966 6.77675C6.93485 6.92176 7.6512 7.06255 8.34281 7.21768C8.28485 7.52014 8.19834 7.8621 8.1498 8.15687C7.97959 8.11533 7.80655 8.07693 7.63465 8.04332C6.25325 7.77322 4.87431 7.44447 3.49301 7.17855C3.5666 6.89407 3.63376 6.53242 3.68729 6.24448Z" fill="#F58023"/>
<path d="M4.50421 4.08688L7.37642 5.43443C7.8387 5.65148 8.3515 5.90663 8.8172 6.10636C8.69168 6.34239 8.53536 6.71913 8.42227 6.97094L5.60172 5.65595L4.67254 5.22251C4.49803 5.14122 4.282 5.03448 4.10623 4.96799C4.24157 4.68735 4.37825 4.37243 4.50421 4.08688Z" fill="#F58023"/>
<path d="M7.65173 0.600006C7.7092 0.619831 8.56419 1.79752 8.67219 1.94328L10.5 4.4071C10.2529 4.59533 10.0042 4.78147 9.7539 4.96548C9.72306 4.95773 9.71197 4.94012 9.69302 4.91506C8.75359 3.67183 7.84686 2.39973 6.90274 1.16046C7.15493 0.977033 7.40462 0.790201 7.65173 0.600006Z" fill="#F58023"/>
<path d="M3.39546 8.39664L8.15042 8.39642C8.14871 8.71324 8.14927 9.03006 8.1521 9.34685L3.3969 9.34675L3.39546 8.39664Z" fill="#F58023"/>
<path d="M5.90011 2.11627C6.0256 2.2062 6.17536 2.33949 6.29734 2.44136L6.97938 3.0096C7.82816 3.71603 8.71015 4.47249 9.56696 5.15996L8.97102 5.87673C8.89753 5.85591 5.65994 3.14081 5.30042 2.84255C5.46331 2.67432 5.75644 2.30993 5.90011 2.11627Z" fill="#F58023"/>
</g>
<defs>
<clipPath id="clip0_6324_259">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: null, color: "#484B59" },
{ name: "foursquare", count: 185720, fillRate: "0.0246%", needed: false, icon: "", priority: null, color: "#484B59" },
{ name: "meetup", count: 157123, fillRate: "0.0208%", needed: false, icon: "", priority: null, color: "#484B59" },
{ name: "pinterest", count: 156014, fillRate: "0.0207%", needed: false, icon: "", priority: null, color: "#484B59" },
{ name: "vimeo", count: 133609, fillRate: "0.0177%", needed: false, icon: "", priority: null, color: "#484B59" },
{ name: "aboutme", count: 121811, fillRate: "0.0161%", needed: true, icon:`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6324_2)">
<path d="M0 0H12V12H0V0Z" fill="black"/>
<path d="M2.32362 0.508649C2.44208 0.491114 2.64891 0.500419 2.7717 0.500614L3.55038 0.501775L6.08458 0.501573L8.52684 0.501707C8.84891 0.501717 9.54112 0.483149 9.82601 0.525979C10.1722 0.577329 10.4974 0.723886 10.7652 0.949292C11.1819 1.2959 11.4456 1.76287 11.49 2.30471C11.5049 2.48709 11.5004 2.6848 11.5003 2.86891L11.4995 3.72038L11.4997 6.44113L11.4998 8.61712C11.4998 8.93663 11.5177 9.53672 11.4732 9.82657C11.4212 10.1757 11.2725 10.5032 11.0437 10.7721C10.6886 11.1955 10.2361 11.4404 9.68554 11.4896C9.53854 11.5086 9.33087 11.4994 9.18092 11.4993L8.36993 11.4984L5.74131 11.4986L3.42665 11.4989C3.10508 11.4989 2.45834 11.517 2.17029 11.4733C1.83017 11.4213 1.51043 11.2783 1.24493 11.0594C0.834046 10.7227 0.558774 10.2512 0.513349 9.71965C0.497062 9.52906 0.501158 9.34034 0.501254 9.14931L0.501879 8.31747L0.501506 5.61607L0.50139 3.38662C0.501419 3.10172 0.485944 2.43829 0.524329 2.18516C0.573858 1.83635 0.720186 1.50842 0.946702 1.23859C1.31031 0.800498 1.75858 0.560565 2.32362 0.508649Z" fill="black"/>
<path d="M2.00523 4.50723C2.12972 4.49615 2.42064 4.49489 2.54314 4.51078C2.54972 4.61861 2.55116 4.71742 2.5521 4.82507C2.92888 4.61239 3.16893 4.47866 3.62026 4.50281C3.88514 4.51699 4.19169 4.64512 4.36801 4.84599C4.61764 4.6207 5.06868 4.48278 5.40149 4.50186C5.70898 4.51948 5.95764 4.617 6.17358 4.84107C6.37492 5.04999 6.36091 5.25943 6.36157 5.53171C6.35931 5.73969 6.36615 5.95531 6.36177 6.16552C6.35196 6.63583 6.37614 7.11934 6.35601 7.58889C6.18688 7.59379 5.99406 7.59344 5.82621 7.58162C5.80083 7.05194 5.83446 6.46301 5.82143 5.92811C5.81633 5.71918 5.83519 5.44231 5.81007 5.2418C5.49271 4.91451 5.03594 5.03319 4.70765 5.27131C4.64358 5.31952 4.60342 5.35661 4.54503 5.4114C4.53744 5.56476 4.54416 5.7851 4.54429 5.94493L4.54496 6.97903C4.54504 7.17233 4.55057 7.39739 4.53392 7.58726C4.3821 7.59718 4.16202 7.5914 4.00882 7.58578C3.98925 7.054 4.01329 6.49271 4.00433 5.9583C4.00044 5.72533 4.01376 5.47307 3.99467 5.24242C3.97907 5.22548 3.96269 5.20926 3.94558 5.19384C3.8012 5.06539 3.63585 5.0366 3.44932 5.04446C3.07102 5.06041 2.78783 5.33434 2.54891 5.60866C2.53132 6.25714 2.56455 6.93234 2.54276 7.58043C2.38349 7.59991 2.166 7.59019 2.00447 7.58122C1.98434 6.78645 2.0123 5.98204 2.00064 5.18636C1.99737 4.96338 1.99605 4.72919 2.00523 4.50723Z" fill="white"/>
<path d="M8.32874 4.505C8.78391 4.43988 9.27278 4.66307 9.58039 4.98864C9.96655 5.39736 10.0083 5.78109 9.99565 6.31305C9.79312 6.32391 9.54906 6.3179 9.34294 6.31779L8.22132 6.31712C8.02813 6.31702 7.67752 6.30693 7.5009 6.33171C7.53299 6.47728 7.60541 6.59678 7.70322 6.70789C7.87439 6.90492 8.1181 7.02418 8.37871 7.03846C8.71715 7.05837 8.93467 6.9542 9.17957 6.73754L9.25135 6.67148C9.37027 6.78623 9.52219 6.87568 9.65608 7.01152C9.36672 7.35162 9.03882 7.54011 8.58999 7.58125C8.18684 7.62168 7.78438 7.49819 7.47329 7.23861C6.40615 6.3501 6.94248 4.62219 8.32874 4.505Z" fill="white"/>
<path d="M8.42402 5.04416C8.91979 5.04766 9.24747 5.30083 9.41025 5.76306C9.22344 5.78644 8.70422 5.77442 8.48968 5.77404L7.90721 5.77513C7.78162 5.77523 7.6167 5.7802 7.49577 5.76028C7.63672 5.32689 7.97017 5.07206 8.42402 5.04416Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_6324_2">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: null, color: "#484B59" },
{ name: "flickr", count: 120943, fillRate: "0.0160%", needed: false, icon: "", priority: null, color: "#484B59" },
{ name: "indeed", count: 95964, fillRate: "0.0127%", needed: true, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6324_52)">
<path d="M0 0H12V12H0V0Z" fill="#003B9A"/>
<path d="M6.74355 6.00918L6.76219 6.00879L6.77415 6.02818C6.76344 6.27856 6.77212 6.60179 6.77216 6.85755L6.77288 8.43572C6.77322 8.75937 6.78418 9.08225 6.7572 9.40443C6.70829 9.98846 6.03278 10.1886 5.62083 9.82622L5.61384 9.81936C5.39867 9.60459 5.40394 9.33554 5.40421 9.05119C5.40441 8.83406 5.40583 8.61662 5.40589 8.39947L5.40551 6.28025C6.01054 6.29285 6.19583 6.26213 6.74355 6.00918Z" fill="white"/>
<path d="M5.88376 3.55696C6.43571 3.46346 6.95813 3.83752 7.04744 4.39015C7.13674 4.94278 6.75873 5.46236 6.20544 5.54747C5.65805 5.63167 5.14523 5.25857 5.05687 4.71183C4.96852 4.1651 5.33772 3.64946 5.88376 3.55696Z" fill="white"/>
<path d="M6.24044 2.02037C6.26429 2.01583 6.37911 2.01395 6.41158 2.01322C6.74107 2.00595 7.02786 2.04547 7.33763 2.16436C7.71743 2.31011 8.12221 2.57701 8.30205 2.95636C8.31774 2.98947 8.33162 3.03253 8.3172 3.06777C8.24975 3.10876 8.01921 2.94469 7.9464 2.89776C6.32893 1.85513 4.60538 2.73477 3.61368 4.15501C3.35926 4.53318 3.15366 4.99941 3.00191 5.42796C2.92668 5.6404 2.86877 5.89088 2.76935 6.08944C2.83039 4.22067 4.28108 2.18918 6.24044 2.02037Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_6324_52">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: null, color: "#484B59" },
{ name: "wordpress", count: 57892, fillRate: "0.0077%", needed: true, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6324_273)">
<path d="M0 0H12V5.73695V6.44428V12H0V6.45261V5.82796V0Z" fill="black"/>
<path d="M0 0H12V5.73695C11.9745 5.62249 11.9661 5.47604 11.9494 5.35529C11.9197 5.12866 11.8765 4.904 11.82 4.68253C11.4338 3.15013 10.5852 1.89107 9.24409 1.03913C7.8968 0.179423 6.26194 -0.106574 4.70279 0.244683C3.14384 0.600011 1.7912 1.56289 0.945094 2.91962C0.526466 3.58569 0.237778 4.32504 0.0942912 5.09855C0.0697256 5.24193 0.0498123 5.38605 0.0345826 5.53072C0.0253358 5.62007 0.0185043 5.74332 0 5.82796V0Z" fill="white"/>
<path d="M12 6.44427V12H-1.90735e-06V6.45261C0.0329997 6.58979 0.0501925 6.90722 0.0827885 7.09113C0.200759 7.76742 0.441936 8.41628 0.794315 9.00545C1.58119 10.3269 2.86671 11.3491 4.36815 11.7277C7.42684 12.4987 10.9265 10.6185 11.8 7.54272C11.8659 7.31199 11.9155 7.07685 11.9482 6.8391C11.9643 6.72527 11.9755 6.54144 12 6.44427Z" fill="white"/>
<path d="M5.68371 0.426573C5.91378 0.400603 6.20349 0.419396 6.43347 0.433151C9.29296 0.629279 11.4576 2.73 11.6215 5.60365C11.8098 8.90517 9.54233 11.4546 6.22444 11.6548C6.22203 11.655 6.2196 11.6552 6.21719 11.6554C4.71567 11.7441 3.42936 11.3638 2.2957 10.3525C1.14597 9.32693 0.372152 7.85526 0.287671 6.31273C0.207493 4.84872 0.64731 3.37937 1.63897 2.28699C2.71524 1.1014 4.11078 0.522797 5.68371 0.426573Z" fill="white"/>
<path d="M5.81096 0.954394C5.87588 0.952105 5.94083 0.950593 6.00579 0.949859C7.21961 0.940447 8.41636 1.24211 9.30044 2.11467C9.1143 2.17699 8.88331 2.29778 8.73641 2.42811C8.27972 2.82651 8.56842 3.43733 8.78045 3.88363C9.01038 4.38042 9.29264 4.87327 9.3787 5.42194C9.47247 6.03219 9.34371 6.60521 9.11568 7.16731C8.91705 7.65695 8.57277 8.34167 8.54751 8.87474C8.05861 7.87533 7.6819 6.72029 7.34465 5.66275L6.68354 3.6203C6.96494 3.46758 7.10478 3.59367 7.36627 3.47008C7.41194 3.44849 7.43457 3.39665 7.44557 3.34821C7.44327 3.3379 7.44126 3.31667 7.43348 3.31406C6.79783 3.10158 5.30373 3.1684 4.72945 3.22536C4.62254 3.24 4.36595 3.25768 4.30289 3.3358C4.24165 3.6276 4.83499 3.52749 4.97591 3.59047C5.10824 3.64963 5.22872 3.93034 5.29204 4.05832C5.96796 5.42438 5.52488 6.92148 5.00809 8.25416C4.91789 8.49038 4.81452 8.74327 4.72979 8.98214C4.69476 8.84867 4.53156 8.48802 4.47159 8.33865C4.32628 7.97284 4.18837 7.60412 4.05795 7.23273C3.64432 6.06707 3.26086 4.81004 2.8807 3.62787C3.11526 3.48707 3.31386 3.56773 3.55717 3.47815C3.58903 3.46642 3.6198 3.44685 3.63281 3.41397C3.63665 3.3717 3.61005 3.33006 3.58434 3.2993C3.36383 3.0355 2.72822 3.21281 2.40119 3.22177C2.14218 3.22887 2.05727 3.23588 1.79055 3.20712C1.82851 3.12951 1.86576 3.02383 1.90618 2.93751C2.01445 2.70955 2.15675 2.49938 2.3282 2.31421C3.17628 1.38571 4.59556 1.01126 5.81096 0.954394Z" fill="black"/>
<path d="M5.92979 6.58237C5.96864 6.61437 6.10029 6.84631 6.13439 6.90531C6.83617 8.11943 7.12312 9.50991 7.56341 10.8187C7.50132 10.8333 7.43573 10.852 7.37403 10.8691C6.97438 10.98 6.56577 11.0258 6.15295 11.0488C5.56404 11.0667 5.0612 11.0478 4.50998 10.8167C4.65226 10.474 4.80099 10.0446 4.92824 9.69266C5.17274 9.02609 5.40233 8.35414 5.61683 7.67731C5.6853 7.45607 5.74967 7.23358 5.80991 7.00995C5.8454 6.8785 5.88559 6.70779 5.92979 6.58237Z" fill="black"/>
<path d="M1.24457 3.97992C1.28954 4.0162 1.45474 4.43158 1.49068 4.51632C2.06998 5.90595 2.59663 7.31696 3.06951 8.74633C3.26368 9.31485 3.44578 9.93345 3.65142 10.491C3.56781 10.455 3.48531 10.4165 3.40404 10.3756C2.56708 9.96613 1.86141 9.1497 1.45336 8.32284C0.938007 7.27247 0.772305 6.08472 0.980503 4.9334C1.04672 4.57692 1.12823 4.32113 1.24457 3.97992Z" fill="black"/>
<path d="M10.3834 3.76721C10.4193 3.79087 10.46 3.85571 10.4828 3.89276C11.6546 5.79788 10.825 8.86593 8.98933 10.0516C8.82156 10.1499 8.7104 10.2016 8.53332 10.2721C8.59057 10.1252 8.65612 9.87663 8.70913 9.71466C8.81148 9.40899 8.92058 9.10563 9.03634 8.80479C9.69083 7.07343 10.3819 5.68002 10.3834 3.76721Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_6324_273">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: null, color: "#484B59" },
{ name: "google", count: 57301, fillRate: "0.0076%", needed: false, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6324_57)">
<path d="M0 0H12V12H0V0Z" fill="white"/>
<path d="M1.44337 3.64494C2.0701 2.40455 3.16845 1.46762 4.49212 1.04426C5.78558 0.631638 7.1895 0.744999 8.39999 1.3598C8.83033 1.58196 9.14238 1.82796 9.50667 2.14307C9.02582 2.63202 8.54101 3.11708 8.05232 3.5982C7.49916 3.06602 6.76339 2.80075 5.99974 2.81555C5.19055 2.83575 4.42248 3.17635 3.86427 3.7625C3.51653 4.12458 3.30942 4.48184 3.14061 4.95114C3.09347 4.92232 3.05008 4.88952 3.00641 4.85578C2.64777 4.58002 2.29525 4.29595 1.93408 4.0234C1.77214 3.9012 1.60985 3.75894 1.44337 3.64494Z" fill="#E43E2D"/>
<path d="M3.1393 6.96878C3.413 7.77546 3.9996 8.43819 4.76709 8.80781C5.51325 9.17191 6.39845 9.18594 7.17971 8.9212C7.4448 8.83137 7.60631 8.7365 7.8403 8.59545C7.91887 8.67208 8.10425 8.8086 8.19585 8.8798L8.93191 9.44617C9.05884 9.54414 9.36358 9.8055 9.4742 9.87152C9.14565 10.1893 8.72821 10.4522 8.31538 10.6462C7.05469 11.2383 5.53378 11.2559 4.23468 10.7867C3.08441 10.3714 1.96855 9.38221 1.44836 8.27457C1.54739 8.20721 1.73035 8.05583 1.83114 7.9773L2.53194 7.43246C2.70865 7.29321 2.9551 7.09339 3.1393 6.96878Z" fill="#2AA24C"/>
<path d="M6.05566 4.98996L9.22235 4.99064C9.78211 4.9906 10.3549 4.99685 10.9137 4.99012C10.9494 5.2604 10.9862 5.51368 10.9988 5.78675C11.0558 7.02087 10.7587 8.29982 9.99823 9.29202C9.84335 9.49413 9.66333 9.70022 9.47419 9.87151C9.36357 9.80549 9.05883 9.54413 8.93189 9.44616L8.19584 8.8798C8.10424 8.80859 7.91886 8.67207 7.84028 8.59544C8.45807 8.14566 8.68692 7.72928 8.87191 7.00611C7.93912 7.00407 6.98919 6.99724 6.05747 7.00752C6.05727 6.34704 6.06873 5.6482 6.05566 4.98996Z" fill="#3A7DED"/>
<path d="M1.44836 8.27456C1.34803 8.12568 1.19745 7.70545 1.14346 7.53955C0.74225 6.30663 0.833236 4.80144 1.44369 3.6449C1.61016 3.7589 1.77245 3.90116 1.93439 4.02336C2.29556 4.29591 2.64809 4.57998 3.00672 4.85575C3.05039 4.88948 3.09378 4.92229 3.14092 4.9511C2.89847 5.68136 2.93323 6.2464 3.13929 6.96878C2.9551 7.09339 2.70865 7.2932 2.53194 7.43246L1.83114 7.97729C1.73035 8.05583 1.54739 8.20721 1.44836 8.27456Z" fill="#F1B500"/>
</g>
<defs>
<clipPath id="clip0_6324_57">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: null, color: "#484B59" },
{ name: "crunchbase", count: 33880, fillRate: "0.0045%", needed: false, icon: "", priority: null, color: "#484B59" },
{ name: "dribbble", count: 30525, fillRate: "0.0040%", needed: true, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="12" height="12" rx="1.2" fill="#EA4B8B"/>
<path d="M5.86131 1.23315C8.48885 1.15667 10.682 3.22385 10.7607 5.85132C10.8394 8.47885 8.77394 10.6738 6.14647 10.7546C3.51594 10.8356 1.318 8.76708 1.23924 6.13647C1.16053 3.50592 3.23072 1.3098 5.86131 1.23315ZM5.89159 2.70093C4.07266 2.76082 2.6466 4.28442 2.70702 6.10327C2.76769 7.92235 4.29227 9.34835 6.11131 9.28687C7.92902 9.22535 9.35335 7.7022 9.29295 5.88452C9.23231 4.06663 7.70949 2.64116 5.89159 2.70093Z" fill="white"/>
<path d="M6.45896 6.48048C6.48137 6.47821 6.4741 6.47868 6.49743 6.4916C6.68713 7.03154 6.87046 7.5656 6.98769 8.12735C7.01792 8.27218 7.04591 8.4194 7.08075 8.56301C6.43222 8.83807 5.74105 8.83864 5.0765 8.62441C4.75828 8.50914 4.56485 8.38866 4.29118 8.20151C4.83921 7.33032 5.50165 6.83784 6.45896 6.48048Z" fill="white"/>
<path d="M6.06072 5.53278C6.09781 5.55383 6.25698 5.92006 6.28367 5.97866C5.31703 6.25335 4.43987 7.00356 3.91517 7.84971C3.84674 7.75724 3.77147 7.66608 3.70083 7.57033C3.3534 7.06603 3.21558 6.53336 3.21346 5.92725C4.03612 5.93636 5.2747 5.79672 6.06072 5.53278Z" fill="white"/>
<path d="M4.78697 3.4904L4.79701 3.48959C4.89226 3.52883 5.73391 4.91642 5.8284 5.07753C5.64191 5.11413 5.45914 5.16325 5.27218 5.20053C4.93747 5.26744 4.59963 5.31762 4.25991 5.35085C3.94686 5.38906 3.58779 5.40233 3.27341 5.4052C3.294 5.32858 3.31589 5.25232 3.33907 5.17643C3.57806 4.40486 4.0826 3.86246 4.78697 3.4904Z" fill="white"/>
<path d="M5.7855 3.2275C5.78768 3.22703 5.78986 3.22657 5.79204 3.22612C6.3647 3.1792 6.94778 3.31848 7.43778 3.61629C7.59905 3.7143 7.71204 3.80356 7.84642 3.91132C7.59046 4.18336 7.43977 4.33382 7.11684 4.53944C6.86345 4.69574 6.6678 4.78339 6.3966 4.89876C6.155 4.41428 5.68032 3.71854 5.36703 3.28111C5.51038 3.25989 5.64119 3.24155 5.7855 3.2275Z" fill="white"/>
<path d="M8.16701 4.26013C8.20411 4.27319 8.30881 4.44313 8.33853 4.48705C8.65054 4.94814 8.74347 5.40884 8.79062 5.95136C8.29671 5.85525 7.85228 5.82403 7.35263 5.82658C7.19301 5.82938 7.01363 5.84553 6.85539 5.86333C6.81692 5.7408 6.68328 5.45437 6.62216 5.33921C7.18177 5.1462 7.77986 4.70099 8.16701 4.26013Z" fill="white"/>
<path d="M7.47283 6.29825C7.91887 6.27693 8.32357 6.34185 8.75218 6.45297C8.64231 7.04113 8.4 7.52021 7.98368 7.9494C7.84625 8.08729 7.72854 8.18202 7.576 8.29904C7.56268 8.18328 7.5141 7.97095 7.48844 7.8549C7.37172 7.33788 7.2224 6.82877 7.04137 6.33062C7.18115 6.31134 7.33136 6.30594 7.47283 6.29825Z" fill="white"/>
</svg>`, priority: null, color: "#484B59" },
{ name: "myspace", count: 22452, fillRate: "0.0030%", needed: false, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6323_864)">
<path d="M0 0H1.66632H10.3276H12V1.67922V10.319V12H10.3262H1.67348H0V10.3081V1.68569V0Z" fill="#033AC3"/>
<path d="M2.80353 3.80126C2.84539 3.79783 2.88743 3.79727 2.92936 3.7996C3.18796 3.81453 3.42951 3.93346 3.59902 4.12932C3.72845 4.27692 3.84673 4.50115 3.83321 4.70328C4.30167 4.19347 5.00812 4.03651 5.64082 4.33116C5.95388 4.47695 6.2429 4.76752 6.36898 5.09146C6.41217 5.04597 6.48938 4.99033 6.54192 4.95306C6.89903 4.69974 7.36105 4.55207 7.79877 4.55028C8.37514 4.54438 8.93017 4.76811 9.34132 5.1721C9.57783 5.40772 9.78044 5.73906 9.86071 6.06591C9.88205 6.15306 9.87655 6.43225 9.87702 6.53922L9.87957 7.38515L9.8987 10.2701L9.8989 10.3946C9.74682 10.3882 9.55655 10.3929 9.40125 10.3929H8.47393L5.71223 10.3933C5.70535 9.76112 5.71217 9.1128 5.69806 8.4836C5.61405 8.48985 5.5038 8.48709 5.41822 8.48709H4.94765L3.49018 8.48729L3.47733 6.79401C3.38423 6.80468 3.07128 6.79763 2.96166 6.79763L1.90583 6.79803L1.89308 5.07805C1.89344 4.93289 1.88259 4.71988 1.89691 4.58191C1.90662 4.48843 2.03662 4.26993 2.09861 4.1943C2.29411 3.95579 2.49959 3.83847 2.80353 3.80126Z" fill="#FEFEFE"/>
<path d="M7.81568 1.11698C7.92031 1.11144 8.02507 1.12203 8.12802 1.14015C8.86527 1.26984 9.36823 1.92114 9.40568 2.65033C9.43031 3.08785 9.28031 3.51725 8.9887 3.84435C8.71708 4.14465 8.35413 4.32796 7.94796 4.34897C7.54823 4.36508 7.19568 4.24757 6.89111 3.98425C6.5622 3.6962 6.361 3.28942 6.33167 2.8532C6.29287 2.29299 6.53456 1.73846 6.99004 1.40536C7.24809 1.21658 7.50037 1.13804 7.81568 1.11698Z" fill="#FEFEFE"/>
<path d="M4.89731 1.61348C5.13677 1.58483 5.42617 1.68731 5.61044 1.83758C5.86898 2.04842 6.01006 2.32729 6.04649 2.65446C6.08354 2.98139 5.9894 3.30967 5.78472 3.56729C5.59614 3.80001 5.3458 3.93416 5.04876 3.96503C4.78416 3.9756 4.55185 3.91327 4.34089 3.74632C4.08906 3.54512 3.929 3.25088 3.89689 2.93015C3.82652 2.28972 4.2365 1.68182 4.89731 1.61348Z" fill="#FEFEFE"/>
<path d="M2.87681 1.7142C3.07952 1.7183 3.22517 1.77463 3.38168 1.90569C3.97549 2.40291 3.74499 3.5964 2.90554 3.64226C2.70317 3.64371 2.53765 3.58016 2.38428 3.44741C1.79409 2.93656 2.02793 1.75631 2.87681 1.7142Z" fill="#FEFEFE"/>
</g>
<defs>
<clipPath id="clip0_6323_864">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: null, color: "#484B59" },
{ name: "behance", count: 20992, fillRate: "0.0028%", needed: true, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6324_8)">
<path d="M0 0H12V12H0V0Z" fill="black"/>
<path d="M1.24202 2.93085L3.06171 2.9299C4.11269 2.9298 5.64369 2.74841 6.0104 4.05343C6.09388 4.35049 6.08802 4.75256 5.99493 5.04683C5.88227 5.403 5.63495 5.61206 5.3135 5.77502C6.31121 6.09583 6.47598 7.28762 6.03452 8.1246C5.94527 8.28206 5.86557 8.39242 5.73582 8.52247C5.53671 8.72294 5.28954 8.86905 5.01789 8.94685C4.47875 9.101 3.5672 9.07106 2.99784 9.07088L1.24202 9.06951C1.23433 8.33311 1.24129 7.5843 1.24126 6.84709L1.24202 2.93085Z" fill="#FEFEFE"/>
<path d="M2.66016 6.36612C2.99297 6.37867 3.35472 6.36464 3.69624 6.36741C4.26082 6.37198 4.9425 6.34913 4.97765 7.10738C4.98885 7.34909 4.91414 7.59012 4.74559 7.77031C4.64557 7.85951 4.52507 7.92262 4.39478 7.954C4.17965 8.00794 3.87806 7.9967 3.65372 8.00022C3.32618 8.00534 2.98515 7.99065 2.65862 8.00072L2.66016 6.36612Z" fill="black"/>
<path d="M2.65959 4.00082C2.74519 4.00989 2.93263 4.00382 3.02844 4.00374L3.78524 4.00427C4.05594 4.0064 4.50955 4.00882 4.70263 4.22274C4.92264 4.46649 4.89237 4.93214 4.6548 5.15584C4.36477 5.38586 3.85306 5.35545 3.49943 5.35471L2.65694 5.35314C2.67229 4.93263 2.6591 4.4282 2.65959 4.00082Z" fill="black"/>
<path d="M8.36359 4.37608C8.95792 4.30724 9.69663 4.49516 10.1271 4.93012C10.7215 5.53062 10.7604 6.21333 10.7584 7.00483L7.56013 7.00592C7.56687 7.05313 7.56878 7.10626 7.57432 7.15418C7.61589 7.51353 7.78452 7.83502 8.12813 7.98523C8.40462 8.1061 8.76805 8.12945 9.05363 8.02225C9.25863 7.947 9.42447 7.79206 9.51344 7.59264L10.3731 7.59332L10.6959 7.5942C10.6347 7.89277 10.5564 8.03692 10.3678 8.27591C9.60724 9.23952 7.97086 9.24841 7.06924 8.48345C6.61727 8.09999 6.46128 7.5964 6.41245 7.02088C6.29734 5.66413 6.89973 4.50332 8.36359 4.37608Z" fill="#FEFEFE"/>
<path d="M8.42216 5.32376C8.70465 5.3059 8.94339 5.32233 9.18056 5.49293C9.46033 5.69419 9.51429 5.92881 9.56685 6.24563L8.75977 6.24541L7.59283 6.24597C7.67607 5.74579 7.89487 5.4008 8.42216 5.32376Z" fill="black"/>
<path d="M7.33578 3.18307L9.80281 3.18637C9.80651 3.3923 9.80547 3.59831 9.79969 3.8042C9.63087 3.81856 9.19084 3.80567 9.00467 3.80556L7.33573 3.80618C7.33347 3.59943 7.33548 3.39004 7.33578 3.18307Z" fill="#FEFEFE"/>
</g>
<defs>
<clipPath id="clip0_6324_8">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: null, color: "#484B59" },
{ name: "soundcloud", count: 9172, fillRate: "0.0012%", needed: false, icon: "", priority: null, color: "#484B59" },
{ name: "xing", count: 6723, fillRate: "0.0009%", needed: false, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6323_892)">
<path d="M0 0H1.45556H10.4399H12V12H10.4455H1.4577H0V10.77V1.23007V0Z" fill="#016164"/>
<path d="M8.1646 1.80902C8.37496 1.79954 9.45145 1.78694 9.56741 1.83303C9.62307 1.85517 9.64697 1.91803 9.66965 1.96865C9.6245 2.11129 9.50158 2.30853 9.42377 2.44564L9.07713 3.05946L7.56497 5.73304L7.08031 6.58679C7.01838 6.69702 6.89729 6.89808 6.85343 7.00469C7.24739 7.68713 7.64768 8.45052 8.02727 9.14605L8.41635 9.85332C8.4971 10.0011 8.60273 10.186 8.66235 10.3415C8.57899 10.5078 8.54755 10.4987 8.37087 10.4972L7.56449 10.4979C6.98392 10.4986 7.01265 10.5545 6.72727 10.0313L6.46566 9.55066L5.53311 7.83844C5.41192 7.61694 5.19611 7.19078 5.06622 7.00082C5.21947 6.72093 5.39215 6.42884 5.54997 6.14901L6.80613 3.92156L7.53083 2.63525C7.65076 2.42291 7.76982 2.20301 7.89533 1.99426C7.96427 1.87961 8.03247 1.83617 8.1646 1.80902Z" fill="#CEDC3A"/>
<path d="M2.88375 3.35987C3.12353 3.34937 3.36924 3.35653 3.61708 3.35591C3.82082 3.36503 4.10971 3.32901 4.29898 3.399C4.41127 3.44052 4.59211 3.78952 4.65167 3.89207C4.79025 4.12981 4.92719 4.36849 5.06247 4.60811C5.14144 4.74629 5.25844 4.95717 5.3473 5.08251L4.4025 6.73892C4.25465 6.99923 4.10893 7.27376 3.94925 7.5259C3.90189 7.60068 3.85762 7.6374 3.78447 7.68384C3.68628 7.71991 2.50803 7.70154 2.31541 7.70113C2.23982 7.64871 2.22447 7.62225 2.18521 7.54195C2.23401 7.39618 2.55313 6.86488 2.64756 6.70074L3.56172 5.1002C3.52119 5.00261 3.38403 4.78158 3.32569 4.68231L2.8943 3.94373C2.82606 3.82642 2.72677 3.67952 2.69339 3.55081C2.6558 3.40586 2.78041 3.37751 2.88375 3.35987Z" fill="#FEFEFE"/>
</g>
<defs>
<clipPath id="clip0_6323_892">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: null, color: "#484B59" },
{ name: "reddit", count: 4971, fillRate: "0.0007%", needed: false, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6323_899)">
<path d="M0 0H12V12H0V0Z" fill="#FF4500"/>
<path d="M7.7562 3.0323C8.13925 2.48623 8.85762 2.81119 8.75248 3.43158C8.69601 3.76481 8.24367 3.94245 7.96135 3.76636C7.78867 3.65866 7.73866 3.53586 7.68986 3.34707C7.44457 3.30001 7.1983 3.25687 6.95507 3.19986C6.81503 3.16704 6.67534 3.13312 6.53329 3.11009C6.46823 3.46026 6.40371 3.79048 6.32351 4.13808C6.27381 4.35351 6.24178 4.58252 6.19068 4.80192C6.88118 4.8031 7.70505 5.05218 8.26327 5.46135C8.47752 5.25975 8.78262 5.19172 9.06535 5.28559C9.71603 5.50165 9.79553 6.41228 9.16288 6.71545C9.1652 6.80801 9.16336 6.90064 9.15737 6.99305C9.12012 7.57892 8.88934 7.95568 8.45126 8.34131C7.57014 9.12155 6.0567 9.29642 4.94411 9.01783C4.04972 8.79388 3.04753 8.17939 2.89111 7.19983C2.86779 7.05378 2.87193 6.87589 2.87098 6.72629C2.3924 6.4722 2.24672 5.88862 2.61803 5.47421C2.91623 5.1414 3.40994 5.12491 3.73573 5.42634C4.46153 4.97772 4.9995 4.80056 5.8568 4.75853C5.88429 4.47942 5.98848 4.11334 6.04555 3.83044C6.10974 3.51222 6.16848 3.17703 6.26215 2.86621C6.27809 2.81333 6.30498 2.78814 6.34653 2.75347C6.46142 2.74786 6.78509 2.8337 6.91999 2.85967C7.19601 2.91279 7.48704 2.95694 7.7562 3.0323Z" fill="#FEFEFE"/>
<path d="M7.17773 6.02821C7.37184 6.0044 7.56372 6.087 7.67986 6.24434C7.79599 6.40168 7.81837 6.60939 7.73841 6.78785C7.65845 6.96632 7.48856 7.08789 7.29384 7.10596C6.99886 7.13336 6.73653 6.91884 6.70479 6.6243C6.67306 6.32974 6.88368 6.06429 7.17773 6.02821Z" fill="#FF4500"/>
<path d="M4.68025 6.0046C4.97676 5.97029 5.24463 6.18361 5.27756 6.48028C5.3105 6.77694 5.09592 7.04382 4.7991 7.07537C4.50425 7.10671 4.2395 6.89385 4.20678 6.59914C4.17407 6.30442 4.38569 6.03869 4.68025 6.0046Z" fill="#FF4500"/>
<path d="M4.76546 7.77826C4.85403 7.78294 5.01021 7.91712 5.10893 7.96128C5.23563 8.02057 5.39382 8.09379 5.53168 8.11754C6.04877 8.20666 6.58807 8.18221 7.03776 7.88578C7.0794 7.85938 7.23058 7.77773 7.28019 7.80098C7.46837 7.88919 7.36545 8.00666 7.27249 8.07252L7.25952 8.08151C6.58677 8.54198 5.58236 8.56025 4.87643 8.16237C4.70819 8.06754 4.49509 7.92507 4.76546 7.77826Z" fill="#FF4500"/>
</g>
<defs>
<clipPath id="clip0_6323_899">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: null, color: "#484B59" },
{ name: "gitlab", count: 86, fillRate: "0.0000%", needed: true, icon: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6323_905)">
<path d="M0 0H12V12H0V0Z" fill="white"/>
<path d="M9.10269 1.00519C9.2339 1.00075 9.37327 0.978913 9.47804 1.07642C9.64948 1.23599 10.7899 4.39767 11.0037 4.90417C11.3866 5.79633 11.2006 6.99305 10.524 7.70247C10.2283 8.01258 9.83427 8.28266 9.48865 8.5417L7.97018 9.67738L6.80822 10.5589C6.4929 10.7988 6.06589 11.2675 5.66986 10.9622C5.11812 10.5369 4.54654 10.1274 3.99734 9.69943C3.48278 9.3019 2.94626 8.9104 2.42986 8.52347C1.77934 8.03606 1.19035 7.66552 0.9011 6.8603C0.685613 6.26046 0.673092 5.46862 0.946844 4.8852C1.02534 4.6691 1.11573 4.46577 1.19671 4.25225L1.96138 2.25409C2.10391 1.8887 2.23052 1.49388 2.4071 1.13889C2.42743 1.098 2.52356 1.02949 2.56432 1.00554C2.66726 1.00334 2.75639 1.00001 2.85924 1.00949C2.92138 1.05549 3.02639 1.13846 3.05563 1.21079C3.14376 1.42876 3.20501 1.67235 3.27587 1.89795L3.66706 3.10347C3.75538 3.37906 3.87037 3.6567 3.95016 3.9375C3.97313 4.01837 4.01969 4.13226 4.03492 4.20829C4.75741 4.20235 5.47992 4.20083 6.20243 4.20374C6.75921 4.20379 7.34769 4.19422 7.9024 4.2068L8.63558 1.97915C8.71897 1.72797 8.79472 1.44861 8.88705 1.20011C8.91093 1.13578 9.04073 1.04127 9.10269 1.00519Z" fill="#E3432A"/>
<path d="M3.99734 9.69945C3.48278 9.30193 2.94626 8.91042 2.42986 8.5235C1.77934 8.03608 1.19035 7.66555 0.9011 6.86033C0.685613 6.26049 0.673092 5.46865 0.946844 4.88522C1.00365 4.94496 1.45106 5.07251 1.55953 5.10791C2.34788 5.36527 2.95414 5.86575 3.60055 6.36037C4.39223 6.9456 5.17535 7.57444 5.97783 8.15184C6.07382 8.05764 6.28599 7.91104 6.40467 7.82291C6.61899 7.66252 6.8325 7.50107 7.0452 7.33853L8.52819 6.21641C8.89637 5.93852 9.28694 5.62789 9.68996 5.40377C9.93048 5.27002 10.2783 5.14972 10.5366 5.0481C10.6472 5.00461 10.9162 4.95688 11.0037 4.9042C11.3866 5.79635 11.2006 6.99307 10.524 7.70249C10.2283 8.01261 9.83427 8.28268 9.48865 8.54172L7.97018 9.67741L6.80822 10.5589C6.4929 10.7988 6.06589 11.2675 5.66986 10.9622C5.11812 10.5369 4.54654 10.1274 3.99734 9.69945Z" fill="#FD6E27"/>
<path d="M5.98298 8.16626C6.43774 8.52713 6.96169 8.88222 7.42173 9.24664C7.54385 9.34338 7.87935 9.57471 7.97013 9.67742L6.80816 10.559C6.49285 10.7988 6.06584 11.2675 5.6698 10.9622C5.11807 10.5369 4.54648 10.1274 3.99728 9.69947C4.04238 9.60438 4.64531 9.17699 4.76482 9.08715C5.16931 8.77812 5.57537 8.47114 5.98298 8.16626Z" fill="#FDA327"/>
</g>
<defs>
<clipPath id="clip0_6323_905">
<rect width="12" height="12" rx="1.2" fill="white"/>
</clipPath>
</defs>
</svg>`, priority: null, color: "#484B59" }
];
profilesWithIcons:any
showAllProfiles: boolean = false;
constructor(
  private personSearchService: PersonSearchService,
  private emailCampaignService: CampaignService,
  private localstorageservice: LocalStorageService,
  private modalService: NgbModal,
  private offcanvasService: NgbOffcanvas,
  private route: ActivatedRoute,
  private filterStore: FilterStoreService,
  private roleFitDataService: RoleFitDataService,
  private uploadCandidateService: UploadCandidateService,
  private aggregateService: AggregateService,
  private candidateSelectionService: CandidateSelectionService,
  private sanitizer: DomSanitizer
){
  // Set here (not ngOnInit) since ngOnChanges fires before ngOnInit on first render,
  // and buildCriteriaChips() (called from ngOnChanges) needs searchType already resolved.
  this.searchType = this.route.snapshot.queryParams['type'] || 'search';
}



ngOnInit() {
  this.searchType = this.route.snapshot.queryParams['type'] || 'search';
  this.projectnumber = window.location.pathname.split('/')[2];
  this.redirectSource = this.route.snapshot.queryParams['redirectSource'] || null;
  this.subscription.push(
  this.uploadCandidateService.screeningSuccessMessage$
    .subscribe((message: string) => {
      this.screeningSuccessMessage = message;

      if (message) {
        setTimeout(() => {
          this.uploadCandidateService.clearScreeningSuccessMessage();
        }, 3000);
      }
    })
);

  this.candidate.experience = this.candidate?.experience?.map(obj => {
        const startDate = obj.start_date ? moment(obj.start_date) : null;
        const endDate = moment(obj.end_date || new Date());
        const totalTenure = endDate.diff(startDate, 'years', true);
        obj.totaltenure = this.getFormattedTenure(totalTenure);
        if (obj.is_primary === true || obj.is_primary === 'true') {
          if(obj){
            this.primaryCompanyInformation = obj.company
            if(this.primaryCompanyInformation && this.primaryCompanyInformation['location']){
              this.primaryCompanyInformation['location'] = obj?.company?.location?.name ? obj?.company?.location?.name : obj.location_names[0]
            }
            if(obj.company && obj.company.name){
              this.currentCompany = obj.company.name;
            }
            if(obj.title && obj.title.name){
              this.currentJobTitle = obj.title.name;
            }
            if(obj.totaltenure){
              this.currentTenure = obj.totaltenure;
            }
            if(obj.location_names.length > 0) {
              this.currentexplocation = obj.location_names[0];
            }
            this.currentStartDate = startDate;
            // if(this.currentLocation == null){
            //   if(obj && obj.company && obj.company.location && obj.company.location.name){
            //     this.currentLocation = obj.company.location.name;
            //   }
            // }
          }
        }

        if (!this.currentCompany && !this.currentJobTitle) {
          this.clonedExperience = this.candidate.experience.filter((obj) => obj.is_primary != true && obj.is_primary != 'true');
          if (this.clonedExperience && this.clonedExperience.length) {
            if (this.currentJobTitle == null) {
              this.currentJobTitle = this.clonedExperience[0].title.name;
            }
            if (this.currentCompany == null) {
              this.currentCompany = this.clonedExperience[0].company.name;
            }
          }
        };
        return obj;
  })
  this.clonedExperience = this.candidate.experience.filter((obj) => obj.is_primary != true && obj.is_primary != 'true');
  this.totalTenure = this.getFormattedTenure(this.candidate.totaltenure);
      this.setHighlightsData();
    this.updateVisibleHighlights();
  if(this.calledFrom != 'project-upload-candidates' && this.calledFrom != 'project-inbound-applications'){
    this.highlightsList = this.getTierOneCompanyAndSchoolHilights(this.candidate?.curatedtalentpooltags);
  }
  if(this.calledFrom == 'project-details-view' || this.calledFrom == 'project-upload-candidates' || this.calledFrom == 'project-inbound-applications') {
    this.buildProjectCriteriaChips();
  }
  console.log(this.candidate, "candidate")
 // this.criteriaChips = Object.values(this.summarizeScreeningCriteria ?? {}).filter(v => v?.trim());
  this.socialProfiles()


}
socialProfiles(){
  const platformMap = Object.fromEntries(
    this.socialPlatforms.filter((p:any) => p.icon).map((p:any) => [p.name || p, this.sanitizer.bypassSecurityTrustHtml(p.icon)])
  );
  // social profile
  if(this.candidate?.profiles){
    this.sociaProfiles =   this.candidate.profiles
    this.profilesWithIcons  = this.sociaProfiles.map((p:any) => ({
      network: p.network,
      url: p.url,
      last_seen: p.last_seen,
      icon: platformMap[p.network] || ""
    })).filter((p:any) => p.icon);

  } else if (this.candidate?.contactdetails?.socialprofiles?.existingDetails){
    this.sociaProfiles =   this.candidate.contactdetails.socialprofiles.existingDetails
    this.profilesWithIcons  = this.sociaProfiles.map((p:any) => ({
      network: p.platformname,
      url: p.link,
      last_seen: p.last_seen || null,
      icon: platformMap[p.platformname] || ""
    })).filter((p:any) => p.icon);
  }
  // this.profilesWithIcons.sort((a, b) => a.priority - b.priority);
}

ngOnDestroy(): void {
  this.subscription.forEach(sub => sub.unsubscribe());
};

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  get shouldShowReevaluation(): boolean {
    if (this.isChecked) { return false; }
    const isUploadOrInbound = this.calledFrom === 'project-upload-candidates' || this.calledFrom === 'project-inbound-applications';
    const isPipelineView = this.calledFrom === 'project-details-pipeline-view';
    return ( (isUploadOrInbound && this.candidate?.revaluationrequired === 1 && this.candidate.screening_status !== 'pending') || (isPipelineView && this.candidate?.screeningdetails?.reevaluationrequired === 1) );
  }

  get shouldShowReevaluationForChips(): boolean {
    const isUploadOrInbound = this.calledFrom === 'project-upload-candidates' || this.calledFrom === 'project-inbound-applications';
    if(isUploadOrInbound && this.candidate.screening_status === 'pending'){
      return false;
    }
    return true;
  }

    /**
     * Highlight searched info in results
     * @param data input data to be processed for highlights
     * @param type type of data to be processed for highlights
     */
     highlightInfo(data: string, type: 'current_jobtitle' | 'past_jobtitle' | 'location' | 'skill' | 'currentjobtitle' | 'currentcompany' | 'pastcompany') {
      if(data && data?.length) {
       const dataForHighlight = data?.trim()?.toLowerCase()?.replace(/<.*?>'/g, '')?.replace(/'/g, "");
      // const datafind = keywords.filter(x=>dataForHighlight.includes(x.replace(/[()*"]/g, '').toLowerCase().trim()));
      // if(datafind.length > 0) {
            let highlightedData: any= data;
            let highlightFound: any;
            switch (type) {
              case 'current_jobtitle':
                {
                 if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.title.name'] ) {
                  const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.title.name.keyword']) {
                  const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_title.keyword']) {
                  const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_title']) {
                  const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound);
                 }
               }

                break;
              case 'past_jobtitle':
                {
                  if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.title.name'] ) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.title.name.keyword']) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_title.keyword']) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_title']) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   }
                }
                break;
              case 'location':
                {
                  if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['location_name'] ) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['location_name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                  } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['location_locality'] ) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['location_locality'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                  } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['location_name.keyword'] ) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['location_name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                  }
                  // const highlightFound = (this.candidate && this.candidate.highlight && this.candidate.highlight['location_name'] || this.candidate && this.candidate?.highlight && this.candidate?.highlight['location_locality'] || this.candidate && this.candidate?.highlight && this.candidate?.highlight['location_name.keyword'] || []).find((loc: string) => dataForHighlight.includes(loc.replace(/<.*?>/g, '').trim().toLowerCase()));

                  // highlightFound && (highlightedData = highlightFound);
                }
                break;
              case 'skill':
                {
                  if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['skills'] ) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['skills'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                  } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['skills.keyword'] ) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['skills.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                  }
               }
                break;
                case 'currentjobtitle':
                  {
                    if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.title.name'] ) {
                      const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                      highlightFound && (highlightedData = highlightFound);
                     } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.title.name.keyword']) {
                      const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                      highlightFound && (highlightedData = highlightFound);
                     } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_title.keyword']) {
                      const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                      highlightFound && (highlightedData = highlightFound);
                     } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_title']) {
                      const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                      highlightFound && (highlightedData = highlightFound);
                     }
                  }
                  break;
              case 'currentcompany':
                {
                  if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_company_name'] ) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_company_name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_company_name.keyword']) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.company.name']) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.company.name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.company.name.keyword']) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.company.name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   }
                }
              break;
              case 'pastcompany':
                {
                  if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_company_name'] ) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_company_name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_company_name.keyword']) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['job_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.company.name']) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.company.name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   } if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.company.name.keyword']) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['experience.company.name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound);
                   }
                   if(this.candidate && this.candidate?.highlight && this.candidate?.highlight['lastjob_company_name.keyword']) {
                    const highlightFound = this.candidate && this.candidate?.highlight && this.candidate?.highlight['lastjob_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').replace(/'/g, "").trim().toLowerCase() === dataForHighlight.replace(/'/g, ""));
                    highlightFound && (highlightedData = highlightFound);
                   }


                }
              break;
            }

            return highlightedData;
        }

      //  }



      return data;
    }

 private getTierOneCompanyAndSchoolHilights(curatedtalentpooltags: any[]) {
    const highlightsFormatedData: any[] = [];
      const grouped: Record<string, any> = {};

    if (this.highlightsPillData.fetchTalentIndustries && this.highlightsPillData.fetchTalentIndustries.length) {
      grouped['fetchTalentIndustries'] = { label: "Multi-Industry", value: this.highlightsPillData.fetchTalentIndustries, color: "blue", imageName: "multi-industry" }
    }

    if (this.highlightsPillData.fetchUnicornCompanies && this.highlightsPillData.fetchUnicornCompanies.length) {
      grouped['fetchUnicornCompanies'] = { label: "Unicorn Experience", value: this.highlightsPillData.fetchUnicornCompanies, color: "yellow", imageName: "unicorn-experience" }
    }

    if (this.highlightsPillData?.isTechie) {
      grouped['isTechie'] = { label: "Techie", value: this.highlightsPillData.isTechie, color: "green", imageName: "techie" }
    }

    if (this.candidate?.currentjob_internal_movement || this.candidate?.progression_within_pastcompany) {
      grouped['PromotionTrack'] = { label: "Promotion Track", value: { currentjob_internal_movement: this.candidate?.currentjob_internal_movement, progression_within_pastcompany: this.candidate?.progression_within_pastcompany }, color: "yellow", imageName: "promotion-track" }
    }

    const displayNameConfig: any = {
      "maang": { label: "MAANG", color: "maang", imageName: "maang" },
      "dax 40": { label: "DAX 40", color: "dax", imageName: "dax40" },
      "nasdaq 100": { label: "NASDAQ 100", color: "nasdaq", imageName: "nasdaq100" },
      "nifty 50 / sensex": { label: "Nifty 50 / Sensex", color: "nifty", imageName: "nifty50" },
      "fortune-500 us": { label: "Fortune Global 500", color: "fortuneGlobal", imageName: "fortuneglobal500" },
      "s&p 500": { label: "S&P 500", color: "sp", imageName: "sp500" },
      "big four": { label: "Big 4", color: "bigfour", imageName: "big4" },
      "dow 30": { label: "DOW 30", color: "dow", imageName: "dow30" },
      "fortune-500": { label: "Fortune 500", color: "fortune", imageName: "fortune500" },
      "big oil": { label: "Big Oil", color: "bigoil", imageName: "bigoil" },
      "ftse 100": { label: "FTSE 100", color: "ftse", imageName: "ftse100" },
      "u15 group (canada)": { label: "U15 Group (Canada)", color: "u15group", imageName: "u15" },
      "batx": { label: "BATX", color: "batx", imageName: "batx" },

      "tier-1 school": { label: "Tier-1 School", color: "teal", imageName: "tier1school" },
      "c9 league (china)": { label: "C9 League (China)", color: "c9League", imageName: "c9" },
      "ivy league (usa)": { label: "Ivy League (USA)", color: "ivy", imageName: "ivy" },
      "group of eight (australia)": { label: "Group of Eight (Australia)", color: "navy", imageName: "go8" },
      "russell group (uk)": { label: "Russell Group (UK)", color: "groupOfEight", imageName: "russell" },
    };


  if(curatedtalentpooltags && curatedtalentpooltags?.length){
    for (let el of curatedtalentpooltags) {
      if (!el?.displayname || !el?.name) continue;

      const key = el.displayname.toLowerCase().trim();
      const config = displayNameConfig[key];
      if (!config) continue;

      if (!grouped[key]) {
        grouped[key] = {
          id: Object.keys(grouped).length + 1,
          label: config.label,
          value: [],
          color: config.color,
          imageName: config.imageName
        };
      }

      if (!grouped[key].value.includes(el.name)) {
        grouped[key].value.push(el.name);
      }
    }
  }

    return Object.values(grouped);
  }

    /**
   *
   * Intialises all the fields necessary for showing candidate highlights
   *
   */
  private setHighlightsData() {
    this.highlightsPillData.setTechie(this.isCandidateTechie(this.candidate));
    this.highlightsPillData.setTalentIndustries(this.getTalentIndustries(this.candidate?.experience));
    const extraHighlightsDetails = this.getFFHUnicornAndTierOne(this.candidate?.curatedtalentpooltags);
    this.highlightsPillData.setUnicornCompanies(extraHighlightsDetails.unicorn);
    this.highlightsPillData.setFortuneFH(extraHighlightsDetails.fortune500);
    this.highlightsPillData.setTierOneSchools(extraHighlightsDetails.tierOneSchools);
  }

    isCandidateTechie(data: any) : boolean {
    let isTechie = false;
    if (!!data.profiles && !!data.profiles.length) {
      isTechie = data.profiles.some(item => item.network == "stackoverflow");
    }
    isTechie = isTechie || !!data.github_url;
    return isTechie;
  }

    getTalentIndustries(experiences: any[]): any {

    let industries : {name: string; exp: {};}[] = [];

    experiences.forEach(el => {
      if (!!el?.company?.industry)
        industries.push({
          name : el?.company?.industry,
          exp: this.getExperience(el)
        });
    });
    // industries = _.uniq(industries, x => x.name);

    let data = this.getUniqueIndustries(industries)
    return data;
  }

  getUniqueIndustries(industries){
  const uniqueData = this.uniqueExperience(industries);
  return uniqueData;

  }


  uniqueExperience(data) {
      const result = {};

      for (const item of data) {
          const key = `${item.name}`;

          if (result[key]) {
              if(item.exp.start_date == result[key].exp.start_date) {
                result[key].exp.year = item.exp.year;
                result[key].exp.month = item.exp.month;
              } else {
                 result[key].exp.year += item.exp.year;
                 result[key].exp.month += item.exp.month;

                while (result[key].exp.month >= 12) {
                    result[key].exp.year += 1;
                    result[key].exp.month -= 12;
                  }
              }
          } else {
              result[key] = {
                  name: item.name,
                  exp: { year: item.exp.year, month: item.exp.month, start_date: item.exp.start_date }
              };
          }
      }

      const uniqueAggregatedData = Object.values(result);
      return uniqueAggregatedData;
  }

    getExperience(obj: any) {

    let exp = {}

    if(obj.start_date && obj.end_date !==null &&  obj.start_date !==null){

      let startDate = obj.start_date;
      let endDate = obj.end_date;

      const startDateArray = startDate.split("-");
      const endDateArray = endDate.split("-");

      const startYear = parseInt(startDateArray[0], 10);
      const startMonth = parseInt(startDateArray[1], 10);
      const endYear = parseInt(endDateArray[0], 10);
      const endMonth = parseInt(endDateArray[1], 10);

      let yearDiff = endYear - startYear;
      let monthDiff = endMonth - startMonth;

      if (monthDiff < 0) {
        yearDiff--;
        monthDiff += 12;
      }

      exp = {year:yearDiff, month:monthDiff, start_date: startDate}

    }else{

      if( obj.start_date !==null){
      let startDate = obj.start_date;
      const formattedDate = new Date();
      const year = formattedDate.getFullYear();
      const month = formattedDate.getMonth() + 1;
      const currentDate = `${year}-${month}`;

      const startDateArray = startDate.split("-");
      const endDateArray = currentDate.split("-");

      const startYear = parseInt(startDateArray[0], 10);
      const startMonth = parseInt(startDateArray[1], 10);
      const endYear = parseInt(endDateArray[0], 10);
      const endMonth = parseInt(endDateArray[1], 10);

      let yearDiff = endYear - startYear;
      let monthDiff = endMonth - startMonth;

      if (monthDiff < 0) {
        yearDiff--;
        monthDiff += 12;
      }
      exp = {year:yearDiff, month:monthDiff, start_date: startDate}
      }
    }

    return exp;
  }

    /**
     *
     * @returns An object with list of fortune five hundred, unicorn experience, and tier 1 school experience details.
     *
     */
    private getFFHUnicornAndTierOne(curatedtalentpooltags) : FFHUnicornTierOne {
      const res = {
        fortune500 : [],
        unicorn : [],
        tierOneSchools : []
      };
      if (!curatedtalentpooltags)
        return res;
      for (let el of curatedtalentpooltags) {
        if (el?.type === "experience" && el?.displayname?.toLowerCase() === "fortune-500" && !!el?.name) { res.fortune500.push(el?.name); }
        else if (el?.type === "experience" && el?.displayname?.toLowerCase() === "unicorns" && !!el?.name) { res.unicorn.push(el?.name); }
        else if (el?.type === "education" && el?.displayname?.toLowerCase() === "tier-1 school" && !!el?.name) { res.tierOneSchools.push(el?.name); }
      }
      res.fortune500 = [...new Set(res.fortune500)];
      res.unicorn = [...new Set(res.unicorn)];
      res.tierOneSchools = [...new Set(res.tierOneSchools)];
      return res;
    }

      private updateVisibleHighlights() {
    let highlightsCount = 0;
    if (this.highlightsPillData.fetchUnicornCompanies?.length) {
      highlightsCount++;
      this.hasSomeFilter = true;
    }
    if (this.highlightsPillData.fetchFortuneFH?.length) {
      highlightsCount++;
      this.hasSomeFilter = true;
    }
    if (this.highlightsPillData.fetchTierOneSchools?.length) {
      highlightsCount++;
      this.hasSomeFilter = true;
    }
    if (this.highlightsPillData.isTechie) {
      highlightsCount++;
      this.hasSomeFilter = true;
    }

    if (this.highlightsPillData.fetchTalentIndustries?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if (this.highlightsPillData.fetchTalentIndustries?.length) {
      this.highlightsPillData.setTalentIndustries([]);
    }

    if (this.highlights?.regionname?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if(this.highlights?.regionname?.length) {
      this.highlights.regionname = null;
    }

    if (this.highlights?.companySizes?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if(this.highlights?.companySizes?.length) {
      this.highlights.companySizes = null;
    }

    if (this.highlights?.totalTenure?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if(this.highlights?.totalTenure?.length) {
      this.highlights.totalTenure = null;
    }

    if (this.highlights?.skills?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if(this.highlights?.skills?.length) {
      this.highlights.skills = null;
    }

    if (this.highlights?.titles?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if(this.highlights?.titles?.length) {
      this.highlights.titles = null;
    }

    if (this.highlights?.locationNames?.length && highlightsCount < 4) {
      highlightsCount++;
      this.hasSomeFilter = true;
    } else if(this.highlights?.locationNames?.length) {
      this.highlights.locationNames = null;
    }

  }

  /**
   * Fired when app-add-to-pipeline-stage successfully sets a new stage for this candidate.
   * Bubbles up through childEvents so the parent list (e.g. ProjectPipelineComponent) can
   * refresh its listing and show the updated stage.
   */
  onStageUpdated(event: { candidate: any, stage: string }) {
    const eventData = {
      data: event,
      action: 'stage-updated',
      index: this.index
    };
    this.childEvents.emit(eventData);
  }

  openSlider(candidate) {
    const data = {
      ...candidate,
      highlights: this.highlights,
      highlightsPillData: this.highlightsPillData,
    }
    const eventData = {
      data: data,
      action: 'open-slider',
      index: this.index
    };
    this.childEvents.emit(eventData);
  }

/**
 * Get company information based on the type (main or past)
 * @param type - The type of company information to retrieve
 * @param data - The candidate data
 * @param event - The mouse event
 * @returns
 */
  getCompanyInfo(type:string, data: any, event){
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
    // this.currentCompanyInformation = {}
    let companyData;
    let pastCompanyData = data?.company

    if(type == 'main'){
      if(!this.primaryCompanyInformation?.website){
        return;
      }
      if(this.primaryCompanyInformation?.id || this.primaryCompanyInformation?.name){
        companyData = [
          {
            ...((this.primaryCompanyInformation?.id) && {id: this.primaryCompanyInformation?.id}),
            ...((this.primaryCompanyInformation?.name) && {name: this.primaryCompanyInformation?.name})
          }
        ]
      }

    }else if(type == 'past'){
      if(!pastCompanyData?.website){
        return;
      }
      companyData = [
        {
          ...((pastCompanyData?.id) && {id: pastCompanyData?.id}),
          ...((pastCompanyData?.name) && {name: pastCompanyData?.name})
        }
      ]
    }
    this.personSearchService.getCompanyLogoV2(companyData).subscribe((res: any) => {
      if(res.status == 'success' && res.data){
        let companyDetails = res.data[0]
        if(type != 'main'){
        this.currentCompanyInformation['website'] = companyDetails.website ? companyDetails.website : pastCompanyData.website
        this.currentCompanyInformation['name'] = companyDetails.name ? companyDetails.name : pastCompanyData?.name
        this.currentCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : pastCompanyData?.industry
        this.currentCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : pastCompanyData?.location?.name
        this.currentCompanyInformation['size'] = companyDetails?.size ? companyDetails?.size : pastCompanyData?.size
        this.currentCompanyInformation['linkedin_url'] = companyDetails?.linkedin_url ? companyDetails?.linkedin_url : pastCompanyData?.linkedin_url
        this.currentCompanyInformation['companylogo'] = companyDetails.companylogo
        this.currentCompanyInformation['tags'] = companyDetails.tags
        this.currentCompanyInformation['id'] = companyDetails.id
        this.currentCompanyInformation['key_id'] = companyDetails.id
        this.currentCompanyInformation['facebook_url'] = companyDetails?.facebook_url ? companyDetails?.facebook_url : pastCompanyData?.facebook_url
        this.currentCompanyInformation['twitter_url'] = companyDetails?.twitter_url ? companyDetails?.twitter_url : pastCompanyData?.twitter_url

        }
        if(type == 'main'){
        this.primaryCompanyInformation['companylogo'] = companyDetails.companylogo
        this.primaryCompanyInformation['tags'] = companyDetails.tags
        this.primaryCompanyInformation['key_id'] = companyDetails.id

        }
          //loadn[0].style.display = 'block'

      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['candidate']) {
        this.totalTenure = this.getFormattedTenure(this.candidate.totaltenure);

        this.setHighlightsData();
    this.updateVisibleHighlights();
  if(this.calledFrom != 'project-upload-candidates' && this.calledFrom != 'project-inbound-applications'){
    this.highlightsList = this.getTierOneCompanyAndSchoolHilights(this.candidate?.curatedtalentpooltags);
  }
      // console.log('candidate changes', this.candidate);
      if(
        this.calledFrom == 'project-details-view' ||
        this.calledFrom == 'project-upload-candidates' ||
        this.calledFrom == 'project-inbound-applications'
      ) {
        // this.showCategoryChip = false;
        this.buildProjectCriteriaChips();
      } else if(this.calledFrom == 'project-details-pipeline-view') {
        this.buildProjectPipelineCriteriaChips();
      } else {
        this.buildCriteriaChips();
      }
    }
  }

  //   openUrl(link, type) {
  //   if (!link || !type)
  //     return;
  //   if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
  //     link = "https://" + link;
  //   else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
  //     link = "https://www." + link;
  //   else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
  //     link = "https://www." + link;
  //   else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
  //     link = "https://www." + link;
  //   else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
  //     link = "https://www." + link;
  //   else if (type == 'website') {
  //     link = "https://www." + link;
  //   }
  //   window.open(link, "_blank")
  // }

// Domain overrides for platforms whose actual domain differs from the type name
 domainOverrides: Record<string, string> = {
angellist: "angel.co",
aboutme: "about.me",
};

openUrl(link: string, type: string) {
if (!link || !type) return;

// Link already has protocol -> use as-is
if (/^https?:\/\//i.test(link)) {
window.open(link, "_blank");
return;
}

// Link starts with "www.<something>" -> just add protocol
if (link.startsWith("www.")) {
window.open("https://" + link, "_blank");
return;
}

if (type === "website") {
link = "https://www." + link;
} else {
const domain = this.domainOverrides[type] || type;
const domainPattern = new RegExp(
`(https?:\\/\\/)?(www\\.|in\\.)?${domain}`,
"i"
);
link = domainPattern.test(link) ? "https://" + link : "https://www." + link;
}

window.open(link, "_blank");
}
  private buildCriteriaChips(): void {
  if (this.searchType?.includes('similar-candidate')) {
    this.buildIdealCandidateChips();
    return;
  }
  const summary: Record<string, string> = this.candidate?.screeningCriteriaSummary ?? {};
  const screeningCriteria: { criteria: string; criteria_content: string; score: number }[] =
    this.candidate?.personSearchScore?.screening_criteria ?? [];

  // build a lookup: 'c1' -> score  (screening_criteria uses "C1", so normalize to lowercase)
  const scoreByKey: Record<string, number> = screeningCriteria.reduce((acc, item) => {
    if (item?.criteria) {
      acc[item.criteria.toLowerCase()] = item.score;
    }
    return acc;
  }, {} as Record<string, number>);

  this.criteriaChips = Object.entries(summary)
    .filter(([, value]) => (value as string)?.trim())
    .map(([key, value]) => {
      const score = scoreByKey[key.toLowerCase()] ?? null;
       return {
        key,
        label: value,
        // Prefer the raw text actually sent to the score API over the AI-summarized
        // value, so the tooltip shows the original criteria name the user entered.
        content: this.rawScreeningCriteriaText?.[key] ?? value,
        score,
      };

    });
    this.shortSummary = this.candidate?.shortSummary;
    this.syncRoleFitData();
}

onCheckboxChange(event: Event) {
  const checked = (event.target as HTMLInputElement).checked;
  this.selectionChange.emit({ id: this.candidate.id, checked });
}

/**
 * Builds criteriaChips from the ideal-candidate match data (getChipForIdealCandidate),
 * so they render through the same chip template used for manual screening criteria.
 */
/**
 * Mirrors personSearchScore.category for the ideal-candidate match flow, derived from
 * overall_match_score (0-10 scale) since getChipForIdealCandidate doesn't return a category directly.
 */
get idealMatchCategory(): 'EXCELLENT' | 'POTENTIAL' | 'NOT_A_MATCH' | null {
  const score = this.candidate?.idealCandidateMatch?.overall_match_score;
  if (score === undefined || score === null) {
    return null;
  }
  if (score >= 7) return 'EXCELLENT';
  if (score >= 4) return 'POTENTIAL';
  return 'NOT_A_MATCH';
}

private buildIdealCandidateChips(): void {
 const match = this.candidate?.idealCandidateMatch;
  this.criteriaChips = Object.entries(IDEAL_CANDIDATE_CHIP_LABELS)
    .map(([key, label]) => ({ key, label, content: label, score: match?.[key] ?? null }));
  this.roleFitDataService.setIdealCandidateMatch(this.candidate?.id, match); // NEW
  this.syncRoleFitData();
}

buildProjectCriteriaChips(): void {
  this.criteriaChips = [];
  this.criteriaChips = this.candidate?.screening_response?.screening_criteria.map((item: any) =>{
    return {
      key: item.criteria,
      label: item.summarizedcriteriachip ? item.summarizedcriteriachip : this.getFirstNWords(item.criteria_content, 2),
      content: item.criteria_content, // full criteria text, used for the chip tooltip
      score: item.score
    }
  })
  this.roleFitDataService.setRoleFitData(
    this.candidate?.id,
    (this.candidate?.screening_response?.screening_criteria ?? []).map((item: any) => ({
      criteria: item.criteria,
      criteria_content: item.criteria_content,
      score: item.score ?? null,
    }))
  );
  this.roleFitDataService.setOverallScore(this.candidate?.id, this.candidate?.screening_response?.overallscore ?? null);
}

private getFirstNWords(text: string, n: number): string {
  if (!text) return '';
  const words = text.trim().split(/\s+/);
  const truncated = words.slice(0, n).join(' ');
  return words.length > n ? `${truncated}...` : truncated;
}

/**
 * Pushes the current criteriaChips (key/label/score) into the shared RoleFitDataService,
 * remapped to {criteria, criteria_content, score} so add-to-pipeline can read it directly.
 * Used by buildCriteriaChips and buildIdealCandidateChips, where `label` already holds
 * the full text (unlike the project builders, which store a truncated chip label instead).
 */
private syncRoleFitData(): void {
  this.roleFitDataService.setRoleFitData(
    this.candidate?.id,
    (this.criteriaChips ?? []).map((chip) => ({
      criteria: chip.key,
      criteria_content: chip.content ?? chip.label,
      score: chip.score ?? null,
    }))
  );
  // personSearchScore applies to the search/screening-criteria flow;
  // idealCandidateMatch applies to the similar-candidate flow. Only one is populated
  // at a time depending on which builder called syncRoleFitData.
  const overallScore = this.candidate?.personSearchScore?.overall_screening_score
    ?? this.candidate?.idealCandidateMatch?.overall_match_score
    ?? null;
  this.roleFitDataService.setOverallScore(this.candidate?.id, overallScore);
}

buildProjectPipelineCriteriaChips(): void {
  this.criteriaChips = [];

  let screening_response: any[] = [];
  try {
    screening_response = JSON.parse(this.candidate?.screeningdetails?.screeningcriteriajson || '[]');
  } catch {
    screening_response = [];
  }

  if (screening_response?.length) {
    // Manually screened pipeline candidates: chips come from screeningcriteriajson.
    this.criteriaChips = screening_response.map((item: any) => {
      return {
        key: item.criteria,
        label: item.summarizedcriteriachip ? item.summarizedcriteriachip : this.getFirstNWords(item.criteria_content, 2),
        content: item.criteria_content, // full criteria text, used for the chip tooltip
        score: item.score
      }
    });
    this.roleFitDataService.setRoleFitData(
      this.candidate?.id,
      screening_response.map((item: any) => ({
        criteria: item.criteria,
        criteria_content: item.criteria_content,
        score: item.score ?? null,
      }))
    );
    this.roleFitDataService.setOverallScore(this.candidate?.id, this.candidate?.screeningdetails?.overallscore ?? null);
    return;
  }

  // Candidates added via similarity search don't have screeningcriteriajson - their
  // match breakdown lives in candidatecomparedata instead, in the same shape as
  // idealCandidateMatch (skills/industry/location/etc scored 0-10), so we build the
  // chips the same way buildIdealCandidateChips() does.
  let compareData: any = null;
  try {
    compareData = this.candidate?.screeningdetails?.candidatecomparedata
      ? JSON.parse(this.candidate.screeningdetails.candidatecomparedata)
      : null;
  } catch {
    compareData = null;
  }

  if (!compareData) {
    return;
  }

  this.criteriaChips = Object.entries(IDEAL_CANDIDATE_CHIP_LABELS)
    .map(([key, label]) => ({ key, label, content: label, score: compareData?.[key] ?? null }));

  this.roleFitDataService.setIdealCandidateMatch(this.candidate?.id, compareData);
  this.syncRoleFitData();
  // Prefer the persisted overallscore column; fall back to the compare payload's own score.
  this.roleFitDataService.setOverallScore(
    this.candidate?.id,
    this.candidate?.screeningdetails?.overallscore ?? compareData?.overall_match_score ?? null
  );
}

 /**
   * Used to capitalize first letter of each word
   * @param str
   * @returns
   */
  capitalizeFirstLetter(str: string): string {
     return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
  }


/**
 * Method to re-run AI screening for a candidate.
 * This method is currently a placeholder and does not contain any implementation logic.
 * @param candidateId
 */
  reRunAiScreening(candidateId: string) {
    this.isReRunAiScreeningLoading = true;
    if(this.calledFrom == 'project-details-pipeline-view') {
   const payload = {
      projectnumber: this.projectnumber,
      candidatenumbers: [this.candidate?.basicdetails?.candidatenumber]
    };
this.aggregateService.getPipelineReevaluation(payload).subscribe((response: any) => {
  if (response.success === true) {
    this.isReRunAiScreeningLoading = false;
    this.successMessage = 'Pipeline reevaluation successful.';
    setTimeout(() => {
      this.successMessage = '';
    }, 3000);
    if (this.candidate?.screeningdetails) {
      this.candidate.screeningdetails.reevaluationrequired = 0;
    } else if (this.candidate) {
      this.candidate.screeningdetails = { reevaluationrequired: 0 };
    }
    this.candidateSelectionService.setReevaluationResults(response.data);
const remainingIds = this.candidateSelectionService.getReevaluationIds()
  .filter(id => id !== this.candidate?.basicdetails?.candidatenumber);
this.candidateSelectionService.setReevaluationIds(remainingIds);
  } else {
    this.isReRunAiScreeningLoading = false;
    console.error('Pipeline reevaluation failed:', response.message);
  }
});
    } else {
    const payload = {
      projectnumber: this.projectnumber,
      applicationIds: [candidateId]
    };
    this.uploadCandidateService.getUploadCandidateReRun(payload).subscribe((response: any) => {
      if (response && response.status === 'success') {
        this.isReRunAiScreeningLoading = false;
        this.uploadCandidateService.setScreeningSuccessMessage(
          'We’ll notify you by email once all candidates have been uploaded/imported. Please check back later.'
        );
        // Clear the flag locally so the reevaluation button hides right away.
        if (this.candidate) {
          this.candidate.revaluationrequired = 0;
          this.showCategoryChip = false;
        }
        // set score to null for all chips to show loading state
        this.criteriaChips.forEach((chip: any) => {
          chip.score = null;
        });
        setTimeout(()=>{
          this.uploadCandidateService.setReRunScreeningResponse(response); // for now commented this to avoid the issue of not showing the re-run candidate in the list
        })
      } else {
        this.isReRunAiScreeningLoading = false;
        // this.uploadCandidateService.setReRunScreeningResponse(null);
      };
    }, (error) => {
      this.isReRunAiScreeningLoading = false;
      this.uploadCandidateService.setReRunScreeningResponse(null);
    });
    }

  };

getTitlecase(str: string){
  return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
}
revealContact(candidate: any, type: string) {
  this.openSlider(candidate);
  if(type == 'reveal-contact') {
    this.candidateSelectionService.setRevealContactCandidate({candidate, type});
  }
};

}
